export const EN = {
    'payment.policy.unavailable': 'Failed to load available payment methods. Please try again later.',
    'payment.provider.unavailable': 'This payment method is currently unavailable.',
    'blocked': 'User unavailable for contact',
    'craft': 'Craft',
    'craft.ingredients': 'Ingredients',
    'craft.ready': 'Ready',
    'craft.recipes': 'Recipes',
    'craft.recipes.place': 'Crafting table in Rkachi\'s house, village of Tribesman, island Dealiah',
    'craft.resource.pi_2o_craft_leather': 'Leather',
    'craft.resource.pi_2o_craft_fur': 'Fur',
    'craft.resource.pi_2o_craft_fangs': 'Fangs',
    'craft.resource.pi_2o_craft_orchid': 'Orchid',
    'craft.resource.pi_2o_craft_hogweed': 'hogweed',
    'craft.resource.pi_2o_craft_thorn': 'Sharp Thorn',
    'craft.resource.pi_2o_craft_clothes_bad': 'Simple Clothes',
    'craft.resource.pi_2o_craft_clothes_good': 'Fine Clothes',
    'craft.resource.pi_2o_craft_bouquet_bad': 'Simple Bouquet',
    'craft.resource.pi_2o_craft_bouquet_good': 'Fine Bouquet',
    'craft.resource.pi_2o_craft_spear': 'Spear',
    'craft.resource.pi_2o_craft_gloves': 'Gloves',
    'craft.resource.pi_2o_craft_notepad': 'Notebook',
    'craft.recipe.clothes_bad': 'Simple Clothes',
    'craft.recipe.clothes_bad.ingredients': 'leather x10, fangs x10, orchid x10.',
    'craft.recipe.clothes_good': 'Fine Clothes',
    'craft.recipe.clothes_good.ingredients': 'fur x10, fangs x10, hogweed x10.',
    'craft.recipe.bouquet_bad': 'Simple Bouquet',
    'craft.recipe.bouquet_bad.ingredients': 'orchid x10.',
    'craft.recipe.bouquet_good': 'Fine Bouquet',
    'craft.recipe.bouquet_good.ingredients': 'sharp thorn x10, orchid x10.',
    'craft.recipe.spear': 'Spear',
    'craft.recipe.spear.ingredients': 'fur x10, fangs x10, hogweed x10, sharp thorn x10.',
    'craft.recipe.gloves': 'Gloves',
    'craft.recipe.gloves.ingredients': 'sharp thorn x10, leather x10.',
    'craft.recipe.notepad': 'Notebook',
    'craft.recipe.notepad.ingredients': 'leather x10, fur x10, sharp thorn x10.',
    'craft.recipe.price.prefix': 'Cost per item: ',
    'craft.recipe.price.ore': 'gold ore.',
    'ke': '-',
    'luchshaja.pobeda': 'BEST VICTORY:',
    'troyke': 'TRIO',
    'voidite.v.top.n.i.polu4ite': 'Enter the top-{0} and receive',
    'dobivaniy': ' FINISHES',
    'obmenjat': 'EXCHANGE',
    'vosstanovit.zdorove.vsem.gerojam': 'RESTORE HEALTH TO ALL HEROES?',
    'artefakt.na.maksimalnom.urovne': 'ARTIFACT AT MAXIMUM LEVEL',
    'sila.na.maksimalnom.urovne': 'POWER IS AT MAX RANK',
    'dar.poka.ne.dostupen': 'FORCE NOT YET AVAILABLE',
    'vibranniy.artefakt.budet.razobran': 'The selected artifact will be dismantled. Then we will choose a hero who will receive 25% of the artifact power',
    'tsena.za.edinitsu': 'Price per unit',
    'er.no.nm': 'You must enter a nickname!',
    'er.no.ml.or.phn': 'You must enter an email or phone number!',
    'izmeneno': 'Changed',
    'nachalo.igri': 'GAME START: ',
    'igrok.povishen.do.uchastnika': 'Player promoted to participant',
    'viberite.vremja.na.kotoroe.hotite.zabanit.igroka': 'Select the duration to ban the player',
    'vibrat': 'CHOOSE',
    'doplatit': 'Pay extra',
    'zvuk.vikljuchen': 'SOUND OFF',
    'sapogiskorohodi.nadeti': 'Boots of Speed equipped',
    'bank': 'BANK',
    'zdorove.geroev.vremenno.umenshaetsja': 'HEROES HEALTH TEMPORARILY DECREASED',
    'hour': 'H. ',
    'level.braket': ' (lvl. ',
    'terjaet': ' loses ',
    'po.urovnju': 'By level',
    'po.shliapam': 'By hats',
    'po.paporotnikam': 'Fern',
    'sbor.shliap': 'Hat collection',
    'sbor.paporotnika': 'Fern',
    'izmenenija.vstupjat.v.silu.so.sledujuschego.zadanija.': '*Changes will take effect from the next quest. ',
    'vremja': 'TIME ',
    'a.teper.nazhmi.uluchshit.': 'Now press "Upgrade".',
    'igrok.ponizhen.do.novichka': 'Player demoted to novice',
    'do.povtornogo.otpravlenija': 'UNTIL RESENDING:',
    'nechego.obmenivat': 'Nothing to exchange',
    'otmena': 'CANCEL',
    'nadet.sapogi.skorohodi': 'PUT ON BOOTS OF SPEED',
    'chat.autotranslate': 'AUTOMATIC CHAT TRANSLATION',
    'chat.autotranslate.on': 'Automatic translation enabled',
    'chat.autotranslate.off': 'Automatic translation disabled',
    'zadaniy.vipolneno': 'TASKS COMPLETED:',
    'actualniy.protivnik': 'CURRENT OPPONENT',
    'y.uroven': '-th level',
    'y.uroven.monstra': '-th monster level',
    'slavnaja.pobeda': 'GLORIOUS VICTORY!',
    'and': 'and',
    'izumrud': ' EMERALD',
    'izumruda': ' EMERALD',
    'toward': 'to',
    'viberite.deystvie': 'CHOOSE ACTION',
    'teper.s.nami': ' NOW WITH US!',
    'podat.zajavku': 'SUBMIT APPLICATION',
    'minute': 'm',
    'smenit.za': 'Change in ',
    'v.boju.mogut.uchastvovat.lish': 'ONLY THESE MAY PARTICIPATE IN BATTLE ',
    'zdorove.vosstanovleno': 'Health restored',
    'klass': 'CLASS: ',
    'nagrada': 'REWARD',
    'postroyka.gotova': 'BUILDING COMPLETE',
    'za': 'For ',
    'spisok.pust': 'LIST IS EMPTY',
    'pusto': 'EMPTY',
    'dostignite': 'REACH ',
    'nashi.geroi.raneni.v.bojah': 'OUR HEROES WERE WOUNDED IN BATTLE',
    'nm.short': 'Mmm.. The name is a bit short',
    'zaschita': 'Defense',
    'magazin.predmetov.dostupen.s': 'Item shop available from ',
    'igrok.priglashen.v.klan': 'Player invited to clan',
    'feniks': 'PHOENIX',
    'novaja.pokupka': 'NEW PURCHASE',
    'zaschita.plus': 'DEFENSE +',
    'troll': 'TROLL',
    'skuld': 'Sculd',
    'baltazar': 'DEMON OF Nonexistence',
    'sikji': 'The Serpent Mother',
    'battle_hobbit': 'BATTLE HOBBIT',
    'chest': 'crate',
    'totem': 'TOTEM',
    'close': 'Close',
    'back': 'Back',
    'name.validation': 'Name cannot be empty.',
    'name.length.validation': 'Name cannot be longer than 40 characters.',
    'text.empty.validation': 'Text cannot be empty.',
    'text.length.validation': 'Comment text cannot be longer than 3000 characters.',
    'topic.length.validation': 'Topic text cannot be longer than 20,000 characters.',
    'konets.puti': 'END OF THE PATH',
    'maks.ur': 'MAX. LVL: ',
    'a.teper.vozmem.revansh.dumaju.teper.to.mi.pobedim.etih.monstrov.': 'Now we will take our revenge. I think this time we will defeat those monsters.',
    'seychas': '(now ',
    'shans.otrazit.atk.': '-50%. CHANCE TO REFLECT ATK.',
    'vosstanovit': 'RESTORE',
    'chasov': '12 hours',
    'chat': 'CHAT',
    'zamestitel.lidera': 'Deputy Leader',
    'eto.svobodniy.slot.dlja.predmeta.': 'This is a free slot for an item.',
    'po.prohozhdeniju': 'Upon completion',
    'uluchshit': 'Upgrade',
    'explore': 'Explore',
    'rub': 'RUB.',
    'rub.small': 'rub',
    'uspeshno.uskoreno': 'Successfully accelerated',
    'deystvija': 'ACTIONS',
    'improve.creature.classes': 'Upgrade creature classes',
    'kupi.izumrudi.i.poluchi..v.podarok': 'BUY EMERALDS – GET +100% BONUS!',
    'kupi.izumrudi.i.poluchi..v.podarok2': 'BUY EMERALDS – GET +50% BONUS!',
    'opit.plus': 'EXP +',
    'factory.gift.value.plus': 'FACTORY GIFT VALUE +',
    'dop.uron.dzhinnam': '– ADD. DAMAGE TO genie',
    'o.klane': 'ABOUT THE CLAN',
    'priglasit': 'INVITE',
    'iskljuchen': 'Excluded',
    'posle.voskreshenija.trizhdi.atakuet.obidchika': '– AFTER RESURRECTION, ATTACKS THE OFFENDER THREE TIMES',
    'u.klana.nedostatochno.sredstv': 'The clan lacks sufficient funds',
    'stoimost.postroyki': 'BUILDING COST: ',
    'dostizhenija': 'ACHIEVEMENTS:',
    'popolnenie.kazni': 'TREASURY REPLENISHMENT',
    'one.minuta': '1 minute',
    'viigrano.bitv': 'BATTLES WON:',
    'po.sile': 'By strength',
    'clan.po.urovniu': 'By level',
    'besplatnoe.otkritie.slota.v.podarok': 'FREE SLOT UNLOCK AS A GIFT!',
    'dlja.vas.teper.dostupna.prokachka.klassa.geroja': 'You can now upgrade your hero\'s class!',
    'izza.nizkogo.atmosfernogo.davlenija': 'Due to low atmospheric pressure in the World of Snow, you can\'t stay outside for long. It\'s time to go home. We can return in 6 hours.',
    'atak.dvazhdi.vtoraja.atk.sluch.vragu': '– ATTACKS TWICE. SECOND ATTACK HITS A RANDOM ENEMY',
    'dzhinn': 'genie',
    'v.vashem.klane.maksimalnoe.kolichestvo.uchastnikov': 'Your clan has reached the maximum number of members. Raise the clan level to invite more players.',
    'otkritie.slota': 'SLOT OPENING',
    'comma.lev': ', lvl ',
    'dop.uron.demonam': '– ADD. DAMAGE TO DEMONS',
    'dalee': 'NEXT',
    'ne.hvataet.izumrudov.kupite.v.banke': 'Not enough emeralds? Buy them in the bank!',
    'uchastniki': 'MEMBERS',
    'razblokirovat.slot': 'UNLOCK SLOT?',
    'krasnie.kristalli': 'Red crystals',
    'otlichno.mozhem.podozhdat.sekund.ili.uskorit.i.ne.zhdat.': 'Great. We can wait 15 seconds or speed it up and skip the wait.',
    'izuchaem.silu': 'STUDYING STRENGTH ',
    'comma.zoloto': ', gold: ',
    'etot.slot.mozhno.razblokirovat': 'THIS SLOT CAN BE UNLOCKED',
    'zdorove': 'Health',
    'slot': 'SLOT',
    'vash.hod': 'YOUR TURN!',
    'hod.protivnika': 'OPPONENT\'S TURN',
    'moi.geroi': 'MY HEROES',
    'rinok': 'MARKET',
    'vot.bi.posmotret.chto.v.etom.sunduke': 'I\'d love to see what\'s inside this chest... but carnivorous plants are blocking it! Click them to fight!',
    'radi.vas.videt': 'GLAD TO SEE YOU',
    'snizh.zaschiti.atakujuschego': '– REDUCES ATTACKER\'S DEFENSE',
    's.vozvrascheniem': 'WELCOME BACK!',
    'ref.welcome.header': 'Welcome!',
    'ref.welcome.info': 'Welcome bonus',
    'ref.welcome.label': 'For signing up via a referral link',
    'ref.bonus.header': 'Bonus',
    'ref.bonus.info': 'Referral Bonus',
    'ref.bonus.label': 'For referring friends to the game',
    'ref.bonus.comment': 'Your clan also receives',
    'nagradi.bracket': 'REWARDS (',
    'vi': 'You ',
    'sila.izuchena': 'Power learned!',
    'sila.uluchshena': 'Class upgraded!',
    'net.bonusov': '(no bonuses)',
    'ataka': 'Attack',
    'v.rodnoy.mir': 'TO THE HOMEWORLD',
    'soberite': 'COLLECT',
    'nm.long': 'The name is too long. Maximum characters: ',
    'ukazatel': 'INDICATOR',
    'pobedili.dot': 'won.',
    'ataki.i.zaschiti': 'attacks and defenses',
    'dop.uron.zverjam': '– ADDL. DAMAGE TO BEASTS',
    'krasniy.kristall': ' red crystal',
    'povisit.do.uchastnika': 'PROMOTE TO PARTICIPANT',
    'ch.m.12.59': '12H. 59M.',
    'klan': 'CLAN',
    'hint': 'TIP',
    'hint2': 'HINT',
    'delete.hint': 'Delete hint',
    'hint.unavailable': 'Hint unavailable',
    'klana': 'CLAN',
    'brosili.vizov': 'challenged ',
    'chelovek': 'PERSON',
    'day.dot': 'd. ',
    'zavershit': 'COMPLETE',
    'nam.predstoit.issledovat.etot.mir': 'We must explore this world, fight its dangers, and survive.',
    'uzhe.est.akkaunt': 'ALREADY HAVE AN ACCOUNT?',
    'nekromant': 'Necromancer',
    'smotri.mi.nashli.zoloto': 'Look — we\'ve found gold! Gather it up; it will serve us well later.',
    'zadaniy.poka.net': 'NO QUESTS YET',
    'porazhenie': 'DEFEAT',
    'pobeda': 'VICTORY',
    'battle.force.win': 'WIN',
    'dlja.pokupki.ne.hvataet': 'Not enough to buy ',
    'smenit.imja': 'CHANGE NAME',
    'email.phone': 'EMAIL/PHONE',
    'reyting.klanov': 'CLAN RANKINGS',
    'ostalos.vremeni': 'TIME LEFT',
    'iskat': 'SEARCH',
    'v.magazin': 'To the store',
    'username': 'Username',
    'er.nm.shrt': 'Mmm... The nickname is a bit short',
    'iz.nih.stsenarnih': 'OF THEM SCENARIO:',
    'kubkov.na.arene': 'ARENA RANK:',
    'fraction.points': 'FACTION POINTS:',
    'luchshaja.pobeda.ur': 'Best victory: lvl. ',
    'gotovo': 'Ready',
    'povisit.do.predstavitelja': 'PROMOTE TO REPRESENTATIVE',
    'poluchit.nagradu': 'Claim reward',
    'tekuschiy': ' (CURRENT)',
    'ataka.i.zaschita': 'Attack and Defense',
    'koschey.defence': 'The Deathless Defense',
    'poison.consumable': 'Poison',
    'resurrection.consumable': 'Resurrection',
    'voodoo.doll': 'Voodoo Doll',
    'death.doll': 'Death Doll',
    'weakening.doll': 'Weakness Doll',
    'execution.doll': 'Execution Doll',
    'life.doll': 'Life Doll',
    'resurrection.doll': 'Resurrection Doll',
    'carnage.doll': 'Rage Doll',
    'stone.doll': 'Stone Doll',
    'fire.doll': 'Fire Doll',
    'charm.doll': 'Charm Doll',
    'death.doll.desc': 'Instantly kills \nenemy (does not work\n on bosses and mini-bosses)',
    'weakening.doll.desc': 'Reduces all boons\n of one enemy by 1 \n(works on everyone).',
    'execution.doll.desc': 'Removes all shields of The Deathless\n from all enemies. \nWorks on bosses.',
    'life.doll.desc': 'Revives a slain ally',
    'resurrection.doll.desc': 'Revives all\n slain allies',
    'carnage.doll.desc': 'Increases attack/defense\n of the whole team by x10',
    'stone.doll.desc': 'Removes petrification\n from an ally',
    'fire.doll.desc': 'Removes burning\n from an ally',
    'charm.doll.desc': 'Makes the enemy\n to attack an ally\n (does not work on bosses)',
    'give.marker.consumable': 'Grant marker',
    'remove.marker.consumable': 'Remove marker',
    'creature.is.dead': 'CREATURE IS DEAD',
    'protivnik.mertv': 'This enemy is dead ☠️',
    'atakuem.vot.etogo': 'Attack this one! 👇',
    'neobhodimo.poluchit': 'Required to obtain ',
    'dlja.uluchshenija.nuzhna': 'To upgrade you need ',
    'podobrat': 'PICK UP',
    'vse.sloti.zanjati': 'ALL SLOTS OCCUPIED',
    'nagrada.poluchena': 'Reward received',
    'ataka.plus': 'ATTACK +',
    'otlichno.teper.klikni.na.geroja.': 'Great, now click on the hero.',
    'ataki': 'attacks',
    'er.ps.empt': 'Oops! Password cannot be empty',
    'er.enter.valid.mail.or.phone': 'Phone number must start with a +, and email must contain an @',
    'er.invalid.phone': 'Invalid phone number',
    'er.invalid.mail': 'Invalid email address',
    'vvedite.tekst': 'ENTER TEXT...',
    'hochu.v.klan': 'I WANT TO JOIN THE CLAN!',
    'rekruting': 'RECRUITING',
    'da': 'YES!',
    'net': 'NO',
    'napisat': 'WRITE',
    'factory.info': 'PRODUCES GEARS DAILY (30% CHANCE) OR RANDOM RESOURCES (70% CHANCE) FOR CLAN MEMBERS.',
    'hall.info': 'ALLOWS UPGRADING CERTAIN HERO CLASSES.',
    'zaschischaet.soklanovtsev.v.bojah.otrazhaja.chast.udarov': 'SHIELDS CLANMATES IN BATTLE, REFLECTING PART OF THE DAMAGE.',
    'privet.ja.cheshirskiy.kot.i.tvoy.verniy.kompanon.v.zazerkale': 'Hello! I am the Cheshire Cat, and your faithful companion in Mirrorland.',
    'ne.zhdat.i.poluchit': 'Do not wait and claim ',
    'vibrano': ' (selected) ',
    'vi.uvereni.chto.hotite.sdatsja': 'ARE YOU SURE YOU WANT TO SURRENDER?',
    'viberi.komu.peredat.predmet': 'CHOOSE WHO TO GIVE THE ITEM TO',
    'vremja.vipolnenija': 'time to complete: ',
    'takzhe.vi.mozhete.pereyti.k.reytingu.klanov': 'You can also view the clan rankings and apply to a clan you like. Or create your own clan.',
    'eliksir': 'Elixir',
    'kazna': 'TREASURY',
    'klan.eto.obedinenie.igrokov': 'A clan is a group of players united to make the game easier and more enjoyable.',
    'igrok.ponizhen.do.predstavitelja': 'Player demoted to representative',
    'vremja.uluchshenija': 'UPGRADE TIME',
    'vremja.izuchenia': 'RESEARCH TIME',
    'v.komandnom.zadanii.uchastvujut.vse.chleni.klana.n': '*All clan members participate in the team quest.\n',
    'v.snezhnom.mire': 'IN THE SNOW REALM',
    'igrok.povishen.do.zam.lidera': 'Player promoted to deputy leader',
    'posledniy.vhod': 'LAST LOGIN: ',
    'otdaem': 'GIVE',
    'predstavitel': 'Representative',
    'poka.vas.ne.bilo': 'YOU WERE AWAY',
    'minut.15': '15 minutes',
    'soobschenie': 'Message',
    'iskljuchen.iz.klana': 'Removed from the clan',
    'geroi': 'HEROES',
    'cards': 'CARDS',
    'sinie.kristalli': 'Blue crystals',
    'ustanovite.predpochtitelnuju.slozhnost.zadanija': 'Set your preferred difficulty for the quest in the Snow Realm as you see fit!',
    'arena': 'ARENA',
    'change': 'change',
    'vi.smozhete.v.ljuboy.moment.izmenit.sostav.geroev': 'YOU CAN CHANGE THE HEROES PARTICIPATING IN BATTLE AT ANY TIME',
    'po.aktsii': 'ON PROMOTION',
    'to.wheel': 'SPIN THE WHEEL',
    'to.wheel.free': 'SPIN FOR FREE',
    'zakrit': 'CLOSE',
    'all.emoji': 'All emotes',
    'snizhenie.urona.atakujuschego': '–ATTACKER DAMAGE REDUCTION',
    'uskorit': 'Speed up',
    'noviy.uroven.poluchen': 'New level reached!',
    'prigoditsja.dlja.uluchshenija': 'USEFUL FOR UPGRADE',
    'snachala.zavershim.obuchenie': 'Finish the training first',
    'vam': 'To you',
    'minut.30': '30 minutes',
    'vvedite.imja': 'ENTER NAME',
    'vvedite.nazvanie': 'ENTER A NAME',
    'podtverzhdenie': 'CONFIRMATION',
    'istorija.areni': 'ARENA HISTORY',
    'vashi.geroi': 'YOUR HEROES',
    'ligi.areni': 'ARENA LEAGUES',
    'players.on.positions': 'Players, to your positions!',
    'liga.1': 'Novice League',
    'liga.2': 'Wooden League',
    'liga.3': 'Stone League',
    'liga.4': 'Bronze League',
    'liga.5': 'Silver League',
    'liga.6': 'Gold League',
    'liga.7': 'Diamond League',
    'liga.8': 'Masters League',
    'liga.9': 'Champions League',
    'daily.arena.reward': 'Daily Arena Reward',
    'nagrada.za.sobitie': 'Event Reward',
    'nagrada.za.sobitie.nachislena': 'You have been awarded for participating in the event:',
    'arena.info.1': 'Win in the arena and claim your opponent\'s spot!',
    'arena.info.2': 'All boosters are active in the arena, except the Elixir of Persuasion. Also, Phoenix Dread does not affect Asgardian phoenixes',
    'arena.info.3': 'Collect your reward daily at {0} local time; next reward in ',
    'arena.info.4': 'The higher your rank – the greater the reward!',
    'arena.info.5': 'If your position didn\'t change after a victory – it means the attacked player fought earlier and slipped away',
    'arena.reward.time.info': '* Time until reward can be claimed may be extended',
    'current.league': 'Current League',
    'best.league': 'Best League',
    'current.position': 'Current Position',
    'best.position': 'Best Position',
    'position': 'Position',
    'position.in.rating': 'Position in Ranking',
    'stsenarnoe': 'SCENARIO',
    'sidequest': 'SIDE QUEST',
    'event': 'EVENT',
    'novoe': 'new',
    'zmey': 'SERPENT',
    'novaja.nahodka': 'NEW FIND',
    'zamena.geroja': 'HERO REPLACEMENT',
    'uchastnikov': 'Participants: ',
    'sek': ' sec.',
    'novoe.zadanie.nachnetsja.zavtra.v': 'NEW QUEST STARTS TOMORROW AT ',
    'zver': 'BEAST',
    'imeetsja': 'AVAILABLE',
    'zaschiti': 'defense',
    'esche': 'MORE ',
    'snachala.nuzhno.chtoto.vnesti': 'You must add something first',
    'dobro.pozhalovat.na.rinok': 'Welcome to the market! Here you can buy red and blue crystals.',
    'vpered': 'Forward!',
    'ponizit.do.predstavitelja': 'DEMOTE TO REPRESENTATIVE',
    'otlichno': 'Excellent',
    'poisk.igroka': 'Player Search',
    'poisk.klana': 'Clan Search',
    'otpravit': 'SEND',
    'vi.bolshe.ne.sostoite.v.klane': 'You are no longer a member of the clan.',
    'siniy.kristall': ' blue crystal',
    'nabirayte.opit.i.poluchayte.k.zdorovju': 'Gain experience and receive +{0} to Health for each level',
    'nagrad.poka.net': 'NO REWARDS YET',
    'demon': 'DEMON',
    'magazin.geroev.dostupen.s': 'Hero shop available from ',
    'zajavka.na.vstuplenie.v.klan.podana': 'Clan membership request submitted',
    'artefakt.uspeshno.perekovan': 'Artifact successfully reforged',
    'sobrano': 'Collected ',
    'povisit.do.zam.lidera': 'PROMOTE TO DEPUTY LEADER',
    'teper.v.otrjade': ' now in the party!',
    'viberite.deystvie.': 'CHOOSE AN ACTION.',
    'zaplatit.za.nih.mozhno.zolotom': 'You can pay for them with gold or other crystals – one or the other. Shall we try?',
    'iskljuchit.iz.klana': 'REMOVE FROM CLAN',
    'emissar.privetstvuju': 'Emissary: Greetings, ',
    'dot.no.povorot.zaschischajut': '. BUT TURNS ARE PROTECTED ',
    'pravila.u.menja.takie.pri.perekovke.vibranniy': 'My rules are as follows: when you reforge an artifact, the chosen artifact vanishes, and any selected hero receives 25% of the reforged artifact\'s power.',
    'chat.clana': 'Clan Chat',
    'napisat.klanu': 'Write to the clan...',
    'vi.poka.ne.v.klane': 'You are not in a clan yet.',
    'sistema': 'System',
    'zoloto': 'Gold',
    'vizov': 'challenge ',
    'profil': 'PROFILE',
    'maks.dot': 'MAX.',
    'slozhnoe': 'HARD',
    'noviy.geroy': 'NEW HERO',
    'izumrudi': 'Emeralds',
    'standartnoe': 'STANDARD',
    'start.zadanija': 'START QUEST: ',
    'cherez': 'IN ',
    'neverojatnoe': 'INCREDIBLE',
    'you.br': '(YOU)',
    'your.clan.br': '(your)',
    'clan.history': 'Clan History',
    'dop.uron.cheloveku': '-ADDITIONAL DAMAGE TO HUMANS',
    'reyting': 'Rating',
    'prizy': 'Prizes',
    'place': 'Place',
    'places': 'Places',
    'vi.na.{0}.meste': 'You are in {0} place',
    'klan.otkroet.novie.vozmozhnosti': 'The clan will unlock new possibilities and grant in‑game bonuses. A clan is your people who will come to your aid. Above all, a clan is fellowship and friends.',
    'sredstva.za.postroyki.vzimajutsja.iz.bjudzheta.klana': '*Construction funds are taken from the clan\'s budget.',
    'unikalniy.drakon.so.skidkoy': 'Unique dragon on sale!',
    'nedavno.ja.poluchil.poslanie.ot.belogo.krolika': 'Recently I received a message from The White Rabbit. He wanted to tell us something important, he called for help. We must find him.',
    'viberi.geroja.kotoriy.bolshe.tebe.podhodit': 'WHO ARE YOU?',
    'gdpr.title': 'Personalized Advertising',
    'gdpr.body': 'By allowing this app to show personalized ads, you help keep it free. The app also collects and processes your personal information to improve quality. By tapping ACCEPT, you agree to the terms of the Privacy Policy.',
    'gdpr.accept.button': 'Accept',
    'gdpr.decline.button': 'Decline',
    'gdpr.privacy': 'Privacy Policy',
    'gdpr.terms': 'Terms of Use',
    'beeline.welcome.title': 'Important Information',
    'beeline.welcome.body': 'By pressing Continue, you agree to the terms of the User Agreement',
    'beeline.welcome.accept.button': 'Continue',
    'beeline.payment.confirmation.title': 'Payment Confirmation',
    'beeline.payment.confirmation.text': 'Funds will be deducted from your mobile balance and credited to the account \n within a few seconds.',
    'beeline.payment.confirmation.accept_text': 'Confirm',
    'beeline.payment.confirmation.decline_text': 'Cancel',
    'beeline.payment.confirm.user.agreement.text': 'By proceeding to payment you agree to the',
    'beeline.payment.confirm.user.agreement.link': 'user agreement',
    'beeline.payment.duplicate': 'A purchase is already being processed.\nPlease wait for the reward from the previous one.',
    'beeline.payment.error': 'Failed to start payment.\nPlease try again later.',
    'navsegda': 'Forever',
    'sapogiskorohodi.snjati': 'Boots of Haste unequipped',
    'dalshe': 'Next',
    'prinjat': 'ACCEPT',
    'empty.nm': 'Name cannot be empty!',
    'a.poka.davay.ne.budem.terjat.ni.minuti': 'For now, let us waste no time and set out; I will show you how.',
    'smenit': 'CHANGE',
    'zadat': 'SET',
    'informatsija': 'INFORMATION:',
    'ne.uchastvuet.v.boju': 'Does not participate in combat',
    'poluchit.seychas': 'GET NOW',
    'bonusi': 'BONUSES: ',
    'postroit': 'BUILD',
    'details': 'DETAILS',
    'igrok.ponizhen.do.uchastnika': 'Player demoted to participant',
    'vkljuchit.zvuk': 'ENABLE SOUND',
    'peremeschenie': 'MOVEMENT',
    'ustavshiy.magkuznets.proiznosit': 'The weary mage–Forge Master intones: Alas, my strength is spent! Seek another Forge Master.',
    'pochta': 'MAIL',
    'vkljuchit.v.otrjad': 'Add to squad',
    'popolnenija.kr..kristalli': 'Refills. Red crystals: ',
    'novichok': 'Novice',
    'drakon': 'DRAGON',
    'otlichno.schit.teper.daet.k.zaschite': 'Excellent! The shield now grants +3 to defense. Let us return to the road.',
    'legkoe': 'EASY',
    'brosil': ' threw ',
    'zadanie.vipolneno': 'QUEST COMPLETED',
    'sled.ur.bracket': ' (NEXT LVL ',
    'kto.budet.luchshim.iz.luchshih': 'WHO WILL BE THE BEST OF THE BEST?',
    'pervaja.smena.oboydetsja.besplatno': 'The first change is free. All subsequent gender changes will cost ',
    'dari': 'FORCES',
    'artifacts': 'ARTIFACTS',
    'opit': 'Experience: ',
    'good.points': 'Order Points',
    'evil.points': 'Shadow Points',
    'tickets': 'Tickets',
    'zahodite.v.igru.zavtra.i.poluchite': 'LOG IN TOMORROW AND RECEIVE ',
    'vstupit': 'JOIN',
    'a.teper.viberem.geroja.kotoriy.poluchit.': 'Now choose the hero who will receive +',
    'zvuk.vkljuchen': 'SOUND ENABLED',
    'zdorove.cherez.min': 'HEALTH +1 IN 1 MIN',
    'zdorove.cherez': 'HEALTH +1 IN ',
    'vi.poluchaete': 'YOU RECEIVE',
    'razblokirovat': 'UNLOCK',
    'mifril': 'Mithril',
    'write.message': 'Write...',
    'kuznitsa': 'FORGE',
    'predmeti': 'ITEMS',
    'smenit.pol': 'CHANGE GENDER',
    'smenit.sposob.oplaty': 'PAYMENT METHOD',
    'smena.sposoba.oplaty': 'CHANGE PAYMENT METHOD',
    'vi.pitaetes.smenit.sposob.oplaty': 'SELECT AN APPROPRIATE PAYMENT METHOD',
    'viberite.sposob.oplaty': 'Select an appropriate payment method',
    'current.payment.method': 'CURRENT PAYMENT METHOD:',
    'payment.method.recommended': '(RECOMMENDED)',
    'xsolla.label': 'XSOLLA',
    'robokassa.label': 'ROBOKASSA',
    'snizhenie.ataki.protivnika': '–ENEMY ATTACK REDUCTION',
    'otpravit.pismo': 'SEND MESSAGE',
    'krasn.krist.': 'Red cryst.',
    'proigrali.nichego.chtobi.luchshe.srazhatsja.davay.podberem.etot.schit': 'Lost? No matter. To fight better, let us take this shield.',
    'lider': 'Leader',
    'dialog': 'DIALOGUE',
    'supp.info': 'This message is for Mirrorland technical support. Please describe your problem or question in detail, clearly and precisely.',
    'ozhidayte.priglashenija.v.klan.': 'AWAIT AN INVITATION TO THE CLAN.',
    'slabosti': 'WEAKNESSES: ',
    'sdatsja': 'SURRENDER',
    'vipolneno': 'COMPLETED: ',
    'dop.uron.nekromantam': '–ADDITIONAL DAMAGE TO NECROMANCERS',
    'do.kontsa': 'TIME REMAINING: ',
    'dop.uron.jascheram': '–ADDITIONAL DAMAGE TO LIZARDS',
    'igrok.prigleshen.v.klan': 'Player has been invited to the clan',
    'uyti.v.otstavku': 'RESIGN',
    'doplatit.izumrudami': 'PAY THE DIFFERENCE WITH EMERALDS?',
    'use.offer': 'USE THE STORE PROMOTION!',
    'zaschita.klana': 'CLAN DEFENSE ',
    'otlichno.geroy.poluchit': 'Excellent – the hero will receive ',
    'vozmozhnost.vstupit.v.klan.otkroetsja.s': 'THE ABILITY TO JOIN THE CLAN WILL OPEN AT ',
    'vibor.geroja': 'HERO SELECTION',
    'otlichno.ah.chut.ne.propustil.eta.kuchka.s.kristallami.nam.tozhe.nuzhna': 'Excellent! Ah, I almost missed it—this pile of crystals will be useful to us as well!',
    'izuchit': 'LEARN',
    'dobro.pozhalovat.na.arenu': 'WELCOME TO THE ARENA!',
    'priglasit.v.klan': 'INVITE TO THE CLAN',
    'vnesti': 'contribute',
    'pozhertvovat': 'DONATE',
    'zavidev.vas.kuznetsmag.ozhivljaetsja': 'Seeing you, the Forge Master-mage brightens and intones: "Welcome to my forge!"',
    'y.uroven.prjamo.seychas': '–th level right now',
    'bil.v.igre': 'Last online: ',
    'minute.dot': 'm.',
    'smenit.besplatno': 'Change for free?',
    'golem': 'GOLEM',
    'ponizit.do.uchastnika': 'DEMOTE TO MEMBER',
    'skidka.na.pervogo.geroja': 'Discount on the first hero!',
    'vihod': 'EXIT',
    'magazin': 'SHOP',
    'one.chas': '1 hour',
    'gruppa': 'GROUP',
    'priobretenie.sputnika': 'PURCHASE COMPANION',
    'priobretenie.sputnikov': 'PURCHASE COMPANIONS',
    'podderzhka': 'SUPPORT',
    'dlja.uluchshenija.neobhodima.pobeda': 'To upgrade, you must win against a monster of level ',
    'hero.can.improve.forces.up.to.rank': 'Hero can improve all forces to rank ',
    'vse.molotki.zaniati': 'All magical hammers are busy with upgrades!',
    'dlja.uluchshenija.neobhodim': 'To upgrade you need ',
    'initsializatsija.proshla.uspeshno': 'Initialization completed successfully',
    'sinie.krist': 'Blue cryst.',
    'vi.pitaetes.smenit.pol.vashego.personazha': 'You are attempting to change your character\'s gender',
    'v.boy': 'TO BATTLE',
    'zadanie': 'QUEST',
    'dop.uron.vsem.vragam': '–ADDITIONAL DAMAGE TO ALL ENEMIES',
    'k.doroge': 'To the road',
    'uvelichte.svoy.otrjad.vplot.do..geroev': 'Increase your squad to as many as 6 heroes!',
    'mag': 'MAGE',
    'vzjat': 'TAKE',
    'zadanija': 'QUESTS',
    'uchastnik': 'Participant',
    'ezhednevnoe': 'DAILY',
    'kogda.geroy.naberet': '[color',
    'neobhodimo': 'REQUIRED',
    'kolichestvo.shagov.v.snezhnom.mire.ogranicheno.n': 'The number of steps in the snow world is limited.\n',
    'voyti': 'enter',
    'kapituljatsija': 'SURRENDER',
    'ur.dot': 'level ',
    'idet.uluchshenie': 'Upgrade in progress',
    'idet.izuchenie': 'Research in progress',
    'proigral': 'lost.',
    'takzhe.obratite.vnimanie.na.moment': 'Also note: at the moment the numbers may shift slightly depending on level and the number of participants.',
    'one.den': '1 day',
    'novaja': 'new',
    'pomogite.svoemu.klanu.uchastvuyte.v.komandnom.zadanii': 'Aid your clan. Join the team quest — it can only be completed by working together.',
    'igrok': 'Player: ',
    'igrokk': 'Player',
    'igroka': 'player',
    'ponizit.do.novichka': 'DEMOTE TO NOVICE',
    'uroven': 'level',
    'ur.': 'level',
    'viberite.na.kogo.zamenit': 'CHOOSE WHO TO REPLACE?',
    'mi.nashli.i.sobrali.resursi.eto.ochen.horosho': 'We have found and gathered the resources! This is most welcome – they will serve us well. For now, let us press on.',
    'nagrada.klanu': 'CLAN REWARD: ',
    'nedostatochno.resursov': 'Not enough resources',
    'nedostatochno.biletov': 'Not enough tickets',
    'povorot': 'TURN',
    'slozhnost.zadanija': 'QUEST\nDIFFICULTY',
    'arena.esche.ne.otkrilas.podozhdite.nemnogo': 'The arena is not open yet, please wait a moment...',
    'postroyki': 'BUILDINGS',
    'ataku': 'Attack',
    'summarniy.prirost': 'TOTAL INCREASE',
    'prirost': 'INCREASE',
    'chto.takoe.klan': 'WHAT IS A CLAN?',
    'sozdat.klan': 'CREATE CLAN',
    'er.nm.lng': 'Nickname is too long. Maximum ',
    'er.nm.same': 'You entered the current nickname ',
    'zabanit.igroka': 'BAN PLAYER',
    'stroitsja': 'UNDER CONSTRUCTION',
    'ur.large.dot': 'LV.',
    'hero': 'Hero',
    'protivnik': 'Opponent',
    'change.of.your.position': 'Change of Your Position',
    'smena.pola': 'GENDER CHANGE',
    'takim.obrazom.za.boy.mozhno.poluchit': 'Thus, in a battle you can receive up to 6 points in total depending on the number of opponents.[/color]\n\n',
    'vi.pokinuli.klan': 'You have left the clan',
    'kazna.popolnena': 'TREASURY REPLENISHED',
    'vidish.eto.schit.kotoriy.mi.nashli': 'You see, this is the shield we found. It\'s a good start, but we can make it better. Click the shield to upgrade it.',
    'registratsija': 'REGISTRATION!',
    'igrok.izgnan.iz.klana': 'Player has been expelled from the clan',
    'igrok.povishen.do.predstavitelja': 'Player promoted to representative',
    'kristalli': 'Crystals',
    'ups': 'OOPS',
    'no.forces.to.learn': 'NO FORCES TO LEARN.',
    'no.forces.to.learn2': 'All of the hero\'s available forces have already been learned.',
    'ups.warlock': 'Warlock cannot upgrade rank. However, any force is learned immediately at rank two.',
    'ups.titan': 'Titan cannot upgrade rank. However, any force is learned immediately at rank three.',
    'ups.angel': 'Angel cannot upgrade rank. However, any force is learned immediately at rank four.',
    'ups.archangel': 'Archangel cannot upgrade rank. However, any force is learned immediately at rank five.',
    'ups.archititan': 'Archititan cannot upgrade rank. However, any force is learned immediately at rank four.',
    'ups.yotun': 'Jotun cannot upgrade rank. However, any force is learned immediately at rank five.',
    'ups.asg.phoenix': 'An Asgardian Phoenix cannot upgrade rank. However, any force is learned immediately at rank five.',
    'ups.warlock.short': 'Warlock does not advance in rank.',
    'ups.titan.short': 'Titan does not advance in rank.',
    'ups.archititan.short': 'Archititan does not advance in rank.',
    'ups.angel.short': 'Angel does not advance in rank.',
    'ups.archangel.short': 'Archangel does not advance in rank.',
    'ups.yotun.short': 'jotun does not advance in rank.',
    'ups.asg.phoenix.short': 'Asgardian Phoenix does not advance in rank.',
    'kupit': 'BUY',
    'spisok.sushestv': 'CREATURE LIST',
    'five.minut': '5 minutes',
    'skidki.na.vseh.geroev': 'Discounts on all heroes!',
    'viberi.kto.iz.geroev.poluchit.bonus': 'Choose which hero will receive the bonus',
    'uvelichivaet.opit.poluchaemiy.za.boy.vsem.uchastnikov.klana': 'INCREASES EXPERIENCE GAINED IN BATTLE FOR ALL CLAN MEMBERS.',
    'no.mon': 'Insufficient funds to purchase',
    'bank.izumrudov.dostupen.s': 'Emerald Bank is available from ',
    'ne.hvataet': 'NOT ENOUGH',
    'umensh..uron.vragamkrome.nekr.': '– REDUCES DAMAGE TO ENEMIES (EXCEPT NECR.)',
    'nanosit.uron.atakujuschemu': '– DEALS DAMAGE TO THE ATTACKER',
    'dial.l': 'DIALOGUE LIST',
    'do.kontsa.predlozhenija': 'UNTIL THE END OF THE OFFER',
    'no.msg': 'No messages',
    'smiley.img': 'Smiley image',
    'smiley': 'Smiley',
    'answer': 'Quote',
    'copy.msg': 'Copy',
    'delete.message': 'Delete',
    'forw.message': 'Forwarded message',
    'max.message.len': 'Maximum message length is 1000 characters.',
    'chlen': 'Member',
    'dlja': 'FOR ',
    'hochet.imenno.v.vash.klan': 'Wants specifically to join your clan',
    'uspey.kupit': 'HURRY, BUY!',
    'komandnoe.zadanie.segodnja': 'TEAM QUEST TODAY',
    'vi.poluchaete.noviy.uroven': 'You have reached a new level!',
    'one.nedelja': '1 week',
    'brac.boev': '),   BATTLES: ',
    'izumrudov': ' emeralds',
    'zdes.igroki.srazhajutsja.drug.s.drugom': 'Here players fight each other.',
    'na.arenu': 'TO THE ARENA!',
    'mozhno.ispolzovat.v.boju': 'CAN BE USED IN BATTLE',
    'ispolzovat': 'USE',
    'snjat.sapogi.skorohodi': 'REMOVE SWIFTWALKER BOOTS',
    'po.kubkam': 'By cups',
    'by.arena.position': 'By arena',
    'pobedil': 'won.',
    'vas.priglashajut.v.klan': 'You are invited to join a clan',
    'etot.slot.poka.ne.dostupen': 'This slot is not available yet.',
    'skidki.na.vseh.geroev.v.magazine': 'DISCOUNTS ON ALL HEROES IN THE SHOP!',
    'snizh.zaschiti.vraga.pri.udarah': '-REDUCED ENEMY DEFENSE WHEN STRUCK',
    'otpravitsja.v.snezhniy': 'You can go to the Snow World no more often than once every ',
    'uluchshit.do.urovnja': 'Upgrade to level ',
    'uluchshit.do.ranga': 'Upgrade to rank ',
    'podrobnee.o.rangah': 'more about ranks',
    'explore.new.force': 'Learn a new power',
    'poluchaem': 'RECEIVE',
    'otsutstvujut': '-ABSENT',
    'viberi.kto.iz.geroev.poluchit.predmet': 'CHOOSE WHICH HERO WILL RECEIVE THE ITEM',
    'pokinut.klan': 'LEAVE CLAN',
    'v.snezhniy.mir': 'TO THE SNOW WORLD',
    'zaschitu': 'Protection',
    'darim.vam.ezhednevniy.podarok': 'WE GIVE YOU A DAILY GIFT',
    'zagruzka': 'LOADING',
    'snachala.viberite.artefakt.dlja.perekovki.': 'First choose an artifact to reforge.',
    'spets.predlozhenie': 'SPECIAL OFFER!',
    'hochet.v.ljuboy.klan': 'Wants to join any clan',
    'vi.ushli.v.otstavku': 'You have resigned',
    'slozhnost.skorrektirovana': 'Difficulty has been adjusted',
    'obnovit': 'UPDATE',
    'net.svobodnogo.mesta.dlja.artefakta': 'NO FREE SPACE FOR AN ARTIFACT',
    'odin.iz.starih.geroev.budet.iskljuchen.iz.otrjada': 'ONE OF THE VETERAN HEROES WILL BE REMOVED FROM THE SQUAD',
    '4ast.budet.iskl': 'Part of the veteran heroes will be removed from the squad',
    'v.profil': 'TO PROFILE',
    'ne.hvataet.izumrudov': 'Not enough emeralds!',
    'personazh.polnostju.zdorov': 'Character is fully healthy',
    'creature.not.dead': 'Can only be used on dead creatures',
    'prochee': 'OTHER',
    'vosstaet.posle.smerti': '–REVIVES AFTER DEATH',
    'er.ps.lng': 'Password is too long. Maximum ',
    'peredat': 'Transfer',
    'gotovi.priobresti.sputnika': 'READY TO ACQUIRE A COMPANION?',
    'ur.klassa': ', CLASS LVL: ',
    'zazerkale.mir.geroev.i.volshebnikov.monstrov.i.tayn.': 'Mirrorland – a world of heroes and wizards, monsters and mysteries. ',
    'oshibka.initsializatsii': 'Initialization error',
    'kazhdiy.raz.kogda.geroy.dobivaet.vraga': '[size',
    'postroyki.klana': 'CLAN BUILDINGS',
    'zaversheno.uluchshenie': 'UPGRADE COMPLETE',
    'zaversheno.uluchshenie.dara': 'COMPLETE UPGRADE OF THE FORCE',
    'teper.vladeet': 'now owns ',
    'teper.vladeut': 'now own ',
    'novim.darom': 'with a new force.\nKeep it up!',
    'novimi.darami': 'with new forces.\nKeep it up!',
    'k.klanu': 'TO THE CLAN',
    'jascher': 'LIZARD',
    'uvi.sloti.vseh.ostalnih.geroev.zanjati': 'UNFORTUNATELY, ALL OTHER HEROES\' SLOTS ARE OCCUPIED!',
    'horosho': 'GOOD',
    'ok': 'OK',
    'predmet.uspeshno.priobreten': 'Item successfully acquired!',
    'predmeti.uspeshno.priobreteni': 'Items successfully acquired!',
    'kontrataka': '–COUNTERATTACK',
    'vikljuchit.zvuk': 'TURN OFF SOUND',
    'er.ps.n.mtch': 'Oops! The entered passwords do not match',
    'confirm': 'CONFIRM?',
    'rang': 'RANK',
    'ranga': 'RANK',
    'hero.rang': 'HERO RANK',
    'can.improve.forces': 'YOU CAN UPGRADE FORCES!',
    'force.ranks': 'RANKS OF FORCE',
    'forces': 'FORCES',
    'reforge': 'ARTIFACT REFORGING',
    'clan.max.mem': 'CLAN AT MAXIMUM CAPACITY',
    'home': 'TIME TO GO HOME',
    'fights': 'BATTLES',
    'fights.in': 'BATTLE IN',
    'go.level': '–LEVEL',
    'heroes': 'HEROES',
    'items.gen': 'ITEMS',
    'forces.gen': 'forces',
    'force.gen': 'force',
    'max': 'MAX.',
    'edit': 'EDIT',
    'block': 'Block',
    'init.txt': 'ORIGINAL TEXT',
    'force': 'FORCE',
    'rank': 'RANK.',
    'editing': 'EDITING',
    'save': 'SAVE',
    'clan.cr': 'CLAN CREATION',
    'clan.nm': 'Choose a name for your clan',
    'ent.nm': 'Enter a name',
    'create': 'CREATE',
    'name': 'NAME',
    'pass': 'PASSWORD',
    'log.in': 'Log in',
    'symbols': 'characters',
    'inv.nm': 'Choose a nickname',
    'inv.ps': 'Choose a password',
    'rpt.ps': 'Repeat the password',
    'mail.or.phn': 'Email or phone (optional)',
    'nm.chng': 'NAME CHANGING',
    'mail.or.phn.chng': 'EMAIL OR PHONE',
    'passw.chng.fill': 'Please fill in all fields',
    'passw.chng.header': 'PASSWORD CHANGING',
    'passw.chng.info': 'Here you can set a new password. After changing your password, you will need to log in again',
    'passw.chng.curr': 'Current password',
    'passw.chng.new': 'New password',
    'passw.chng.new.rpt': 'Repeat the new password',
    'password.reset.forgot': 'Forgot password?',
    'password.reset.header': 'PASSWORD RESET',
    'password.reset.request.info': 'Enter the player\'s name. We will send a password reset link to the email address on file, if available.',
    'password.reset.set.info': 'Enter a new password for the account.',
    'password.reset.send': 'SEND LINK',
    'password.reset.request.success': 'A password reset link has been sent to your email.',
    'password.reset.set.success': 'Password changed. Signing in...',
    'password.reset.name.required': 'Enter the player\'s name',
    'ldng': 'Loading...',
    'lan': 'LANGUAGE',
    'switch.lang': 'Selected language: RUSSIAN. Switch to English?',
    'select.lang': 'Select your language:',
    'logo-class': 'aof-logo-en',
    'gems.mul.gen': 'emeralds',
    'from': 'from',
    'fromC': 'From',
    'discount.used': 'Discounted price',
    'to': 'to',
    'lev.gen': 'level',
    'news.rang.title': 'RANK!',
    'news.rang.subtitle': 'HEROES CAN NOW RANK UP!',
    'news.rang.1': 'Each hero now earns personal experience. Once they reach the required amount, the hero gains a new rank.',
    'news.rang.2': 'Climbing ranks is a long road. But those who succeed will unlock powerful bonuses for their heroes.',
    'news.force.title': 'FORCES!',
    'news.force.subtitle': 'YOUR HEROES HAVE ACCESS TO FORCES!',
    'news.force.1': 'Each hero can now gain a force – a bonus from another class.',
    'news.force.2': 'For example, a human who gains the dragon force can strike twice while lowering the foe\'s defense.',
    'news.force.40.title': 'Hero Page',
    'news.force.40.1': 'Welcome to the refreshed Hero Page!',
    'news.force.40.2': 'There are more options now, and navigation is smoother.',
    'news.force.500.1': 'Wow, everything here has changed!',
    'news.force.500.2': 'Artifacts remain unchanged.',
    'news.force.500.3': 'But forces... Now many heroes will be able to upgrade forces ranks!',
    'news.force.500.4': 'Yes, indeed, just like that! We\'ll tell you all about it now!',
    'news.force.500.5': 'On the "Forces" tab you\'ll see the hero\'s forces around them – both learned and learnable.',
    'news.force.500.6': 'A force available to learn is marked with a green lock.',
    'news.force.500.7': 'A force that can be upgraded is marked with two arrows.',
    'news.force.500.8': 'Remember, upgrading forces takes time.',
    'news.force.500.9': 'Moreover, only two forces upgrades can run at the same time.',
    'news.force.500.10': 'So choose wisely, upgrade only the forces you truly need!',
    'news.force.500.11': 'Different heroes can upgrade forces to different levels.',
    'news.force.500.12': 'And here the most interesting part begins: now the hero who can upgrade forces to a higher rank is more valuable.',
    'news.force.500.13': 'For example, a human can upgrade forces up to rank 5, Asgardian phoenixes up to rank 6. Roccara – to rank 7, and the great Nook-Serra – all the way to epic rank 8.',
    'news.force.500.14': 'But enough words, let\'s play! Forward, on the great journey!',
    'news.rf.title': 'RANK AND FORCES!',
    'news.rf.subtitle': 'RANK AND FORCE PROGRESSION NOW AVAILABLE!',
    'news.rf.1': 'Each hero now gains personal experience and can increase their rank.',
    'news.rf.2': 'Also a hero can receive a force of another class. For example, a human who gains the dragon force can attack twice and lower an enemy\'s defense.',
    'forces.are.cool': '*Adding new powers to your heroes is especially effective, since when you learn an additional power the hero receives only his positive aspects. For example, learning the necromancer\'s power won\'t make the hero vulnerable to genies. However, rank progression is available only for the primary class.',
    'clan.resign': 'Are you sure you want to relinquish leadership of the clan? Leadership will pass to the most worthy clan member.',
    'clan.leave': 'Are you sure you want to leave this clan?',
    'do.you.want.to.buy': 'Do you want to buy ',
    'insufficient.emeralds': 'Not enough emeralds',
    'buy.hammer.agitation': 'Buy the magic hammer, and upgrade as many as {0} force at once!',
    'buy.hammer.agitation2': 'Buy the magic hammer, and upgrade as many as {0} force at once!',
    'd.hammer.for': 'magic hammer for ',
    'th.hammer.for': 'magic hammer for ',
    'pokupka.molotka': 'Hammer Purchase',
    'clan.txt.revert': 'Are you sure you want to revert to the original text? All changes made to the text will be lost.',
    'clan.b.started': 'Construction started',
    'clan.b.completed': 'Construction completed',
    'news.p2.title': 'SEQUEL!',
    'news.p2.subtitle': 'WELCOME TO PART 2!',
    'news.p2.1': 'The game\'s sequel is finally ready! The portal is live, hurry into the world of the Solar Dragons!',
    'news.p2.2': 'Soon you\'ll encounter the portal entrance. Good luck and thank you for being with us!',
    'th.place': '-th place',
    'hour.dot': 'h.',
    'sec.dot': 's.',
    'rang.1': 'Hero rank upgrades are now available to you!',
    'rang.2': 'Each time a character finishes off an enemy, they gain one point of personal experience.',
    'rang.3': 'When the character reaches the required number of points, they gain a new rank and improved class bonuses (retaining all previous ones).',
    'rang.4': 'Raising rank takes time. However, those who manage it will earn powerful bonuses for their heroes.',
    'th.rang.now': '-th rank now?',
    'of': 'of',
    'pict.not.sup': 'Images are not supported yet',
    'message.copied': 'Message copied',
    'exp.t.lev': 'experience to lvl.',
    'red.cr.gen': 'red crystal',
    'red.cr.mul.gen': 'red crystals',
    'blue.cr.gen': 'blue crystal',
    'blue.cr.mul.gen': 'blue crystals',
    'gold.gen': 'gold',
    'exit.sure': 'Are you sure you want to exit the game?',
    'moder': 'MODERATOR',
    'admin': 'ADMINISTRATOR',
    'god': 'DEVELOPER',
    'good.fellow': 'GOOD PLAYER',
    'recieves': 'receives',
    'challenged.female': 'challenged',
    'you.lost': 'you lost.',
    'she.lost': 'she lost.',
    'she.won': 'she won.',
    'best.v.lev': 'best victory: lvl.',
    'clan.exp': 'clan experience',
    'clan.fights': 'clan battles',
    'last.ent': 'Last login',
    'at.y.service': 'Awaiting your command.',
    'req.gain': 'required to collect',
    'bl.cryst': 'blue crystals',
    'hrs': 'hours',
    'best.mul.gen': 'BEST',
    'beast.gen': 'BEAST',
    'demon.gen': 'DEMON',
    'dragon.gen': 'DRAGON',
    'gin.gen': 'GENIE',
    'golem.gen': 'GOLEM',
    'human.gen': 'HUMAN',
    'lizard.gen': 'LIZARD',
    'elf.gen': 'ELF',
    'mag.gen': 'MAGE',
    'necro.gen': 'NECROMANCER',
    'serpent.gen': 'SERPENT',
    'troll.gen': 'TROLL',
    'skuld.gen': 'Sculd',
    'baltazar.gen': 'Balthazar',
    'sikji.gen': 'Sikji',
    'battle_hobbit.gen': 'BATTLE Hobbit',
    'chest.gen': 'crate',
    'totem.gen': 'TOTEM',
    'phoenix.gen': 'PHOENIX',
    'can.imp': 'CAN BE UPGRADED',
    'th.lev.2.batl': '–TH LEVEL TO FIGHT!',
    'disc.to': 'DISCOUNT UP TO',
    'open.slot.with.disc': 'SLOT OPENING WITH DISCOUNT!',
    'pcnt.for.slot': '% OFF SLOT OPENING AS A BONUS!',
    'cl.ftrs': 'CLASS FEATURES',
    'your.active': 'YOUR ACTIVE',
    'boosters2': 'BOOSTERS',
    'imp.cost': 'UPGRADE COST',
    'bld': 'CONSTRUCTION',
    'imp.g': 'UPGRADES',
    'imp': 'UPGRADE',
    'imp.ing': 'UPGRADING',
    'reward_x10_for_win.info': 'If you win the next battle, you will receive 10 times more resources.',
    'elixir_for_win.info': 'If you win the next battle, you will receive 250 blue crystals.',
    'mithril_for_win.info': 'If you win the next battle, you will receive 5 emeralds.',
    'attack_for_win.info': 'If you win the next battle, heroes will get +10 Attack.',
    'defence_for_win.info': 'If you win the next battle, heroes will get +10 Defense.',
    'attack-half-to-all.info': 'All heroes lose half their Attack in the next battle.',
    'defence-half-to-all.info': 'All heroes lose half their Defense in the next battle.',
    'attack-double-to-all.info': 'All heroes gain double Attack in the next battle.',
    'anti-warlock-power.info': 'All heroes gain double Attack and double Defense in the next battle.',
    'attackAll05.info': 'All heroes\' Attack and Defense are reduced by 25% (until you remove the curse).',
    'defence-double-to-all.info': 'All heroes gain double Defense in the next battle.',
    'gin_defence.info': 'In the next battle, the Salvation Crystal will bestow its protection on your genie.',
    'beast_defence.info': 'In the next battle, the Salvation Crystal will bestow its protection on your beasts.',
    'mag_defence.info': 'In the next battle, the Salvation Crystal will bestow its protection on your mages.',
    'human_defence.info': 'In the next battle, the Salvation Crystal will bestow its protection on a human.',
    'dragon_defence.info': 'In the next battle, the Salvation Crystal will bestow its protection on your dragons.',
    'necro_defence.info': 'In the next battle, the Salvation Crystal will bestow its protection on your necromancers.',
    'charmMarker.info': 'In the next battle, one enemy creature will fight on your side.',
    'charm2.info': 'In the next battle, enemies will attack one another.',
    'blueElvenFlowerMarker.info': 'The power of the Elven Flower grants you 100 Defense in the next battle.',
    'redElvenFlowerMarker.info': 'The power of the Elven Flower grants you 100 Attack in the next battle.',
    'yellowElvenFlowerMarker.info': 'The power of the Elven Flower grants you 10 Health in the next battle.',
    'stealCurseMarker.info': 'Your morale will be lower than usual in the next battle.',
    'witchLuckMarker.info': 'The spirits sent by the witch will aid you in the next battle.',
    'witchCurseMarker.info': 'Cursed by the witch, you will suffer severe weakness in the next battle.',
    'threePowerCone.info': 'The power of the mighty tree doubles the heroes\' Defense in the next battle.',
    'fairyMarker.info': 'The fairy\'s benevolent charms aid you in the next battle.',
    'snowflakeMarker.info': 'The victor\'s snowflake weakens your opponent in the next battle.',
    'p6tavPotionMarker.info': 'The tavern potion weakens your opponent in the next battle.',
    'cloverMarker.info': 'The Clover of Fortune grants you good luck in the next battle.',
    'luckyCat.info': 'The lucky cat has granted you luck for the upcoming battle.',
    'healthPlus3Marker.info': 'The Flowers of Immortality grant heroes +3 Health in the next battle.',
    'kettle.info': 'The Dragon\'s Decoction grants all heroes +10 Defense in the next battle.',
    'healthPlus25.info': 'The Enchanted Whirlpool grants all your creatures +25 Health in the next battle.',
    'summonCopyMarker.info': 'Magic Dust summons a copy of a random hero you control in the next battle.',
    'deathCrystal.info': 'The Death Crystal destroys a random enemy in the next battle.',
    'idolOfDestruction.info': 'The Idol of Destruction destroys a random creature in the next battle.',
    'mushDefence500marker.info': 'The mushroom grants +5000 Defense to a random creature you control in the next battle.',
    'mushAttack500marker.info': 'The mushroom grants +500 Attack to a random creature you control in the next battle.',
    'serpentForce.info': 'The Serpent Fungus grants a random hero the power of the serpent in the next battle.',
    'superDefence.info': 'A random hero\'s Defense is increased fivefold, but their Attack is halved in the next battle.',
    'mushroomMarker.info': 'All heroes\' Attack is doubled, but their Defense is reduced to 1 in the next battle.',
    'mushroomMarker2.info': 'The Shaman\'s Mushroom grants all heroes +20 Defense and -10 Attack in the next battle.',
    'looseForcePhoenix.info': 'Your opponents will lose Phoenix power in the next battle',
    'looseForceDeath.info': 'Your opponents will lose Death power in the next battle',
    'looseForceWitch.info': 'Your opponents will lose Witch power in the next battle',
    'looseForceMag.info': 'Your opponents will lose Mage power in the next battle',
    'exp_x10.info': 'If you win the next battle, you will gain ten times the experience',
    'anyHeroAttackX3.info': 'The attack of a random creature, yours or an enemy’s, will be tripled in the next battle',
    '3_vict_sphere.info': 'Win the next three battles to grant +100 to all heroes\' attack',
    'new_level_on_victory.info': 'If you win the next battle, you will immediately gain a new level',
    'pct.for.lev': '% PER BUILDING LEVEL',
    'rep.for.lev': '% REFLECTED HITS PER BUILDING LEVEL',
    'factory.for.lev': '% GIFT VALUE PER BUILDING LEVEL',
    'edit.clan.txt': 'Edit the text as you see fit! Place your clan rules, a greeting to players, or anything else you wish right here.',
    'reload.fail': 'PAGE RELOAD REQUIRED',
    'con.fail': 'OOPS! THE GAME IS UNAVAILABLE. MOST LIKELY AN UPDATE IS IN PROGRESS',
    'try.ltr': 'PLEASE WAIT A MOMENT',
    'connect': 'CONNECT',
    'nm.chng.cmnt': 'You are attempting to change your character\'s name',
    'frc.nm.chng.cmnt': 'You have to change your character\'s name',
    'nm.chng.costs': 'Changing your name will cost',
    'ml.or.phn.chng.cmnt': 'Not set',
    'ml.or.phn.chng.crrnt': 'This will be used for password recovery. Current email or phone:',
    'phn.format.desc': 'The phone number must start with a + and include the country and city codes',
    'set.new.name': 'Choose a new nickname',
    'set.new.email.or.phn': 'Enter a new email or phone number',
    'banned': 'You cannot send messages in chat. Possible reason: chat ban',
    'all.emotions': 'All emotes',
    'min.chat.lvl': 'You need level 10 to send messages!',
    'ent.text': 'Write...',
    'pl.total': 'Total players',
    'cl.total': 'Total clans',
    'online.total': 'Total online',
    'yan': 'YAN',
    'gls': 'gls',
    'OK': 'OK',
    'fm': 'FM',
    'kr': 'KR',
    'tg.star': 'ST.',
    'to.blck.list': 'ADD TO BLACKLIST',
    'from.blck.list': 'REMOVE FROM BLACKLIST',
    'cust.slots': 'CUSTOMIZE SLOTS',
    'backpack': 'BACKPACK',
    'poniatno': 'Understood',
    'backpack.info': 'Items for battle are selected randomly unless a slot selection algorithm is set',
    'block.user': 'Add this player to the blacklist? This will delete the entire conversation with them and prevent them from sending you messages.',
    'unblock.user': 'Remove this player from the blacklist?',
    'blocked.feed': 'The player has been added to your blacklist and will no longer bother you.',
    'unblocked.feed': 'Player removed from the blacklist',
    'slots.set': 'Slots configured',
    'scroll': 'SCROLL',
    'random': 'RANDOM',
    'type': 'TYPE: ',
    'effect': 'EFFECT: ',
    'power': 'POWER: ',
    'weakest': 'THE WEAKEST',
    'strongest': 'THE STRONGEST',
    'conf': 'Confirm',
    'cust': 'SETTINGS',
    'consls': 'POTIONS AND SCROLLS',
    'cns.txt': 'Customize which potions and scrolls are used in battle. Set your preferences for each slot. When available, items will be used in battle according to your settings.',
    'continue': 'Continue',
    'rej': 'REJECT',
    'invtd': 'Invited',
    'rjctd': 'Request rejected',
    'need.accpt': 'To register you must accept the privacy policy and consent to the use of cookies.',
    'priv.pol': 'privacy policy',
    'public.offer': 'public offer',
    'user.agreement': 'user agreement',
    'i.acc': 'I accept',
    'acc.cook': 'I consent to the use of cookies.',
    'sublead': 'Temporary leader',
    'zamlead': 'Deputy Leader',
    '2.exch': 'FOR EXCHANGE',
    'sel.heroes': 'SELECT HEROES TO TRADE TOWARD A PURCHASE',
    'hero.dec.price': 'EACH HERO TRADED WILL REDUCE THE PURCHASE PRICE',
    'her.sel': 'HEROES SELECTED:',
    'add.attack': 'additional attacks',
    'h.shop': 'HERO SHOP',
    'h.usual': 'COMMON',
    'h.legend': 'LEGENDARY',
    'h.myth': 'MYTHIC',
    'her.unavailable': 'These heroes are not available yet.',
    'min.lev.legend': 'To access Legendary heroes you must defeat the enemy min. ',
    'min.lev.myth': 'To access Mythic heroes you must defeat the enemy min. ',
    'myth.her': 'MYTHIC HEROES',
    'myth.ava': 'Mythic heroes are now available!',
    'too.many.her': 'Have too many unused heroes? Exchange them for a mythic hero!',
    'myth.are.cool': 'Mythic heroes possess unique forces unavailable to any other. They are very costly. However, you can use old, unwanted heroes toward the purchase.',
    'warlock': 'WARLOCK',
    'druid': 'DRUID',
    'witch': 'WITCH',
    'shaman': 'SHAMAN',
    'dragonslayer': 'DRAGONSLAYER',
    'dragon_2': 'DRAGON RNG.3',
    'warlock.gen': 'WARLOCK',
    'druid.gen': 'DRUID',
    'witch.gen': 'WITCH',
    'shaman.gen': 'MONK',
    'dragonslayer.gen': 'DRAGONSLAYER',
    'dragon_2.gen': 'DRAGON RNG.3',
    'can.not.improve.rank': 'THIS CREATURE CANNOT IMPROVE ITS RANK.',
    'success.purch': 'PURCHASE SUCCESSFUL!',
    'gems.arrived': 'YOUR EMERALDS HAVE ARRIVED!',
    'h.pl': 'HEALTH OF ALL HEROES +',
    'disc.myth': 'DISCOUNT ON MYTHIC HEROES ',
    'get': 'GET',
    'get.for.clan': 'GET FOR CLAN',
    'all.h': 'TO ALL HEROES',
    'disc.pl': '+DISCOUNT ',
    'ev.myth': '% ON ANY MYTHIC/ASCENDED HERO',
    'us.inf.1': 'Here you will find inexpensive yet inexperienced heroes.',
    'us.inf.2': 'Level them up properly and they will become powerful support for your team.',
    'leg.inf.1': 'Legendary heroes are seasoned and powerful.',
    'myth.inf.1': 'Mythic heroes possess unique forces unavailable to any others.',
    'myth.inf.2': 'They are expensive, but you can use old unwanted heroes toward the purchase.',
    'myth.in.clan': '*Mythic heroes are available in the clan shop',
    'catto': 'Cheshire',
    'joanne': 'Alice',
    'johnny': 'Johnny',
    'news': 'NEWS',
    'manual': 'HELP',
    'c.chests': 'PROMO: CHESTS!',
    'c.chests2': 'NEW CHESTS!',
    'c.chests3': 'SUPER CHESTS!',
    'c.wheel': 'WHEEL OF FORTUNE!',
    'c.hero': 'FREE HERO!',
    'c.snow_world': 'SNOW PASS AS A GIFT',
    'c.boosters': 'FREE BOOSTER!',
    'c.portal_discount': 'PORTAL AS A GIFT!',
    'c.gems_plus_50': 'GEMS AS A GIFT!',
    'c.chest': 'Promo: Get a chest as a gift!',
    'c.wheel2': 'Promo: Spin the Wheel of Fortune!',
    'c.hero2': 'Promo: Get a hero as a gift!',
    'c.snow_world2': 'Promo: Get a pass to Snowworld as a gift!',
    'c.boosters2': 'Promo: Get boosters as a gift!',
    'c.portal_discount2': 'Promo: Get up to 100% discount on portals!',
    'c.gems_plus_50_2': 'Promo: +50% FREE when purchasing emeralds!',
    'tickets.received': 'Tickets received',
    'hero.received': 'Hero received',
    'gems.received': 'Emeralds received',
    'attack.increased': 'Attack increased',
    'defence.increased': 'Defense increased',
    'health.increased': 'Health increased',
    'crystals.received': 'Crystals received',
    'artifact.received': 'Artifact received',
    'force.received': 'Force received',
    'm.chest': 'MY CHEST',
    'tickets.conds': 'Get a golden ticket for every {0} emeralds purchased in the shop!',
    'tickets.sources': 'Spin the wheel and win valuable prizes!',
    'wheel.det': 'Odds of winning',
    'spin.for': 'Spin for ',
    'spin.free': 'Spin\nfor free',
    'take.award': 'Claim\nreward',
    'you.have.free.spins': 'Free spins: ',
    'you.have': 'You have ',
    'silv.conds': 'Buy any amount of emeralds and get a Silver Chest!',
    'silv.det': 'What might be inside a Silver Chest?',
    'gold.conds': 'Buy 10,000 emeralds or more and get a Gold Chest.',
    'free.hero.conds': 'Buy at least {0} emeralds and receive a free hero!',
    'free.snow.world.conds': 'Buy at least {0} emeralds and receive a free pass to the Snow World for {1} hours.',
    'portal.discount.cond': 'Buy at least {0} emeralds and get 50% off any portal!',
    'portal.discount.cond2': 'Buy at least {0} emeralds and get any portal free!',
    'booster.cond': 'Buy any amount of emeralds and get +100% experience for 8 hours as a bonus',
    'booster.cond2': 'Buy at least {0} emeralds and receive the Platinum Pack for 72 hours as a bonus (battle XP +400%, health per level +400%, regeneration rate x20).',
    'gold.det': 'What might be inside a Gold Chest?',
    'camp.no.more': 'This promotion can be used no more than',
    'camp.wheel.limit': 'The number of tickets per day is limited (Tickets obtained: {0}/{1})',
    'tms.used': '–times per day (used: ',
    'tm.used': '–time per day (used: ',
    'cmp.dates': 'Promotion dates: ',
    'slv.chst': 'SILVER CHEST',
    'gld.chst': 'GOLD CHEST',
    'az.chst': 'AZURE CHEST',
    'lv.chst': 'LAVA CHEST',
    'amb.chst': 'AMBER CHEST',
    'jd.chst': 'JADE CHEST',
    'open': 'OPEN',
    'all.her': 'to all heroes',
    'one.her': 'to one hero',
    'chst': 'CHEST',
    'unique.hero.1': 'PUMPKIN',
    'unique.hero.2': 'Sir Gremlinet - HERO WITH 3 FORCES',
    'unique.hero.3': 'MADAM Sabrina - HERO WITH 10 FORCES',
    'hlth.plus': 'HEALTH +',
    'pick.who': 'Choose which hero will receive ',
    'ft.news': 'News',
    'ft.sugg': 'Suggestions',
    'ft.disc': 'Game Discussion',
    'ft.player.exp': 'player_experience',
    'ft.talk': 'Chat',
    'ft.play': 'Games',
    'ft.help': 'Game Help',
    'ft.letopis': 'Chronicle',
    'ft.quest': 'Questions & Answers',
    'ft.meet': 'Introductions',
    'ft.comp': 'Contests',
    'ft.rules': 'Rules',
    'ft.cl.info': 'Information',
    'ft.cl.stuff': 'Clan Affairs',
    'ft.cl.talk': 'Clan Chat',
    'ft.cl.oth': 'Other',
    'frm': 'FORUM',
    'adv': 'ANNOUNCEMENT',
    'clan.name': 'Clan Name',
    'enemy.attack': 'Enemy Attack',
    'enemy.defence': 'Enemy Defense',
    'enemy.attack.defence': 'Enemy Attack and Defense',
    'enemy.health': 'Enemy Health',
    'player.attack': 'Player Attack',
    'player.defence': 'Player Defense',
    'player.attack.defence': 'Player Attack and Defense',
    'player.health': 'Player Health',
    'adv.desc': 'Write an announcement for your clanmates (maximum 180 characters)',
    'adv.placeholder': 'Announcement text',
    'publish': 'Publish',
    'dlt': 'DELETION',
    'dlt.conf': 'The topic will be permanently deleted. Are you sure?',
    'tpc.crt': 'CREATE TOPIC',
    'tpc.crtn': 'TOPIC CREATION',
    'tpc.edt': 'EDIT TOPIC',
    'cmnts': 'COMMENTS',
    'com.edt': 'EDIT COMMENT',
    'com.dlt.conf': 'The comment will be permanently deleted. Are you sure?',
    'write': 'WRITE',
    'com.crtn': 'COMMENT CREATION',
    'discn': 'DISCUSSION',
    'srch.sett': 'SEARCH SETTINGS',
    'srch': 'SEARCH',
    'arena.sett': 'ARENA SETTINGS',
    'choose.arena.time': 'Choose a time for the arena reward (local time)',
    'by.rate': 'BY RATING',
    'by.new': 'BY RECENCY',
    'sort': 'SORT',
    'tags': 'TAGS',
    'filts': 'FILTERS',
    'by.all.time': 'ALL TIME',
    'by.week': 'PAST WEEK',
    'by.day': 'PAST DAY',
    'crtd': 'Created: ',
    'edtd': ', edited ',
    'delete': 'DELETE',
    'auth': 'Author: ',
    'guest': 'Guest',
    'to.top': 'Go to topic >',
    'read.all': 'Read more >',
    'cln.frm.pr': '*To create a topic on the clan forum you must have at least the member role.',
    'comm.frm.pr': '*To create a topic on the global forum you must be at least level 10 and not be banned.',
    'private': 'Private',
    'top.name': 'Topic Title',
    'top.cont': 'Content',
    'theme': 'Topic Theme',
    'gst.lbl': 'Private (for clanmates) or Guest (for everyone)',
    'opr': 'POLL',
    'dr.pl': 'Dear Adventurer!',
    'shr.opin': 'Share your feedback:',
    'd.u.like': 'Do you like the game?',
    'rt.on.yan': 'Rate our game on Yandex.',
    'rt.on.google': 'Rate our game on Google.',
    'hlp.evlv': 'This will help us improve the game.',
    'rate': 'RATE',
    'like': 'LIKE',
    'n.like': 'DISLIKE',
    'm.ty.op': 'Thank you very much for your feedback!',
    'ty.for.op': 'Thank you for your feedback',
    'we.do.best': 'We\'ll do our best to get better! :)',
    'boosters': 'BOOSTERS',
    'now': 'NOW: ',
    'ttl': 'Title',
    'no.boo': 'BOOSTER UNAVAILABLE',
    'repl.boo': 'Replace the current bonus with this booster?',
    'boo.act': 'Activating booster ',
    'prol.boo': 'Extend booster by ',
    'act.till': 'ACTIVE UNTIL ',
    'repl': 'REPLACE',
    'append': 'EXTEND',
    'ui.ch.ttl': 'Game View',
    'ui.nw': 'Switch the game view to the new one (this will require reloading the game)?',
    'ui.old': 'Switch the game view to the original one (this will require reloading the game)?',
    'ui': 'INTERFACE',
    'gfts': 'GIFTS',
    'gft': 'GIFT!',
    'gft.by.fotostrana': 'GIFT FROM FOTOSTRANA!',
    'gft.by.vk': 'GIFT FROM Vk Play!',
    'gft.by.text': 'Accept 1000 emeralds as a gift. With love from VK Play.',
    'gft.fotostrana.text': 'Accept 50 emeralds as a gift. With love from Fotostrana.',
    'with.us': 'Thank you for being with us!',
    'gft.rcvd': 'Yes!! Gift received!',
    'gft.all.rcvd': 'Yeah! All gifts claimed!',
    'gft.new': 'NEW GIFT!',
    'u.have': 'You have',
    'n.g': 'new gifts!',
    'ne.g': 'You have a new gift!',
    'from2': 'from: ',
    'acpt.all': 'ACCEPT ALL',
    'nxt': 'NEXT',
    'next.rang': 'next rank',
    'force.has.max.rang': 'This force \n has the maximum rank',
    'acpt': 'ACCEPT',
    'gft.pck': 'GIFT SELECTION',
    'desire': 'WISH',
    'ent.desire': 'WRITE AN ACCOMPANYING MESSAGE FOR YOUR GIFT',
    'ent.desire.2': 'Write a message to the player',
    'pres': 'GIVE',
    'n.txt': '- no text -',
    'g.d.conf': 'Are you sure you want to delete the gift?',
    'fr': 'FRUITS',
    'food': 'FOOD',
    'ny': 'N.Y.',
    'ans': 'CREATURES',
    'mk.gft': 'SEND GIFT',
    'gift.gems': 'SEND EMERALDS',
    'gft.snt': 'You have sent a gift to the player. It will make them happy!',
    'titan': 'TITAN',
    'titan.gen': 'OF THE TITAN',
    'show.txt': 'Show text',
    'hide.txt': 'Hide text',
    'txt.hid': 'Text hidden',
    't.h.all': 'Text hidden from everyone.',
    't.s.all': 'Text is now visible to everyone.',
    'br.camp': 'Unique Bandersnatch creature – now discounted!',
    'v.o.ttl': 'VERSION',
    'v.o.int': 'OUTDATED VERSION',
    'v.o.body': 'Your version is out of date. Click the "Update" button. In some cases you may also need to reload the browser to fetch the new version.',
    'cln.top': 'CLAN THEME',
    'pick.thm': 'CHOOSE A THEME FOR YOUR CLAN',
    'tpcs': 'THEMES',
    'thm.cmnt': 'THE FIRST 3 THEME CHANGES ARE FREE. AFTER THAT – 250 EMERALDS FROM THE CLAN BUDGET.',
    'silv.gn': 'SILVER',
    'gld.gn': 'GOLDEN',
    'brl.gn': 'DIAMOND',
    'silv.nm': 'SILVER',
    'gld.nm': 'GOLDEN',
    'brl.nm': 'DIAMOND',
    'bon.gms': ' BONUS EMERALDS!',
    'by.mr': 'Buy more',
    'gms.silv': 'emeralds and receive Silver status.',
    'det': 'MORE DETAILS',
    'auto.rotation': 'auto-rotation',
    'cngrts.stat': 'CONGRATULATIONS ON YOUR',
    'b.sts': 'NEW STATUS!',
    'st.desc.1': 'From now on, you will earn bonus points equal to ',
    'st.desc.2': '(you will receive bonus points equal to ',
    'pct.gms': '% of purchased emeralds.',
    'pnts.got': 'YOU HAVE BEEN CREDITED ',
    'pnts': 'BONUS POINTS',
    'pnts.nom': 'BONUS POINTS',
    'mk.purch.dr.week': 'Make a purchase within a week and receive one additional emerald for each bonus point.',
    'bn.lim': '* But not more than the purchase amount',
    'u.hv': 'YOU HAVE ',
    'stts': ' STATUS',
    'mx.st': 'You have the highest status.',
    'buy.get': ' emeralds in total (excluding gifts) and receive ',
    'before.obs': 'before expiration:',
    'ag.buy': 'Buy ',
    'ag.buy.mr': 'Buy another ',
    'rem': 'REMAINING',
    'bf.obs': ' UNTIL BONUS POINTS EXPIRE!',
    'u.hv.bns': ' You have bonus points:',
    'hv.bns': '(bonus points:',
    'bt.agit': 'Make a purchase to receive emeralds for them.',
    'pct.fr': '% of the purchase amount)',
    'or.get': 'OR GET',
    'pl.btl': '+1 BATTLE FOR',
    'do': 'UP TO',
    'to.the': 'UP TO',
    'w.adv': 'WATCH AD',
    'w.rol': 'FOR WATCHING A VIDEO',
    '4gems': 'FOR EMERALDS',
    't.p.d': '-X TIMES A DAY',
    'w.a.g': 'WATCH THE AD AND GET ',
    'ws.tdy': 'VIEWS TODAY',
    'wtch': 'WATCH',
    'gn.gems': 'EARN EMERALDS',
    '2.mr': 'NO MORE THAN',
    'rew.lim': 'YOU CAN WATCH NO MORE THAN 3 TIMES PER DAY.',
    'aw': 'REWARD',
    'gt': 'RECEIVE',
    'rew.res': 'Thank you for watching the ad! Views today: ',
    'val': 'LOVE',
    'ifrit': 'IFRIT',
    'ifrit.gen': 'OF IFRIT',
    'life': 'LIFE',
    'life.gen': 'OF LIFE',
    'death': 'DEATH',
    'death.gen': 'OF DEATH',
    'chaos': 'CHAOS',
    'chaos.gen': 'OF CHAOS',
    'wall': 'DEFENSE',
    'wall.short': 'DEF',
    'wall.gen': 'OF DEFENSE',
    'lord': 'LORD',
    'lord.gen': 'OF LORD',
    'vamp': 'VAMPIRE',
    'vamp.gen': 'OF VAMPIRE',
    'luck': 'FORTUNE',
    'luck.gen': 'OF FORTUNE',
    'bers': 'BERSERKER',
    'bers.gen': 'OF BERSERKER',
    'wind': 'WIND',
    'wind.gen': 'OF WIND',
    'sorc': 'SORCERER',
    'sorc.gen': 'OF SORCERER',
    'east': 'EASTER',
    'sst': 'PCS',
    'plc': 'PLACE',
    'km.snow': 'DISTANCE IN SNOW REALM',
    'met': 'meters',
    'b.snow': 'Increases the maximum distance in the Snow Realm.',
    'm.p.lev': 'meters per level',
    'p.lev': 'per level',
    'copy': 'Copy link',
    'pin.topic': 'Pin topic',
    'unpin.topic': 'Unpin topic',
    'copied': 'Link copied',
    'card.used': 'Card used!',
    'spr': 'HELP',
    'spr.forces': 'HELP ON FORCE',
    'sprng': 'MAY EVENTS',
    'june-3': 'Announcement! New rules for hero exchange take effect on June 3.',
    'pck.ava': 'Choose a new avatar',
    'pck.later': 'Later',
    'lvlng': 'LEVELING',
    'lvlg.comb': 'Group leveling set to \'All Heroes\' affects up to 6 heroes. Currently, preference is given to combat heroes. You can switch the setting to prioritize the weakest heroes. Switch?',
    'lvlg.weak': 'Group leveling set to \'All Heroes\' affects up to 6 heroes. Currently, preference is given to the weakest heroes. You can switch the setting to prioritize combat heroes. Switch?',
    'lvlg.comb.st': 'Setting changed. Now the weakest heroes are being leveled',
    'lvlg.weak.st': 'Setting changed. Now combat (strongest) heroes are being leveled',
    'angel': 'ANGEL',
    'archangel': 'Archangel',
    'archititan': 'ARCHITITAN',
    'yotun': 'jotun',
    'asg.phonix': 'ASGARDIAN PHOENIX',
    'asg.phonix.full': 'ASGARDIAN PHOENIX',
    'angel.gn': 'OF THE ANGEL',
    'archangel.gn': 'Archangel',
    'archititan.gn': 'OF THE ARCHITITAN',
    'yotun.gn': 'jotun',
    'asg.phonix.gn': 'OF THE ASGARDIAN PHOENIX',
    'min.lev.top': 'To access top heroes you must achieve victory over an enemy min.',
    'top.her.t': 'SUPREME HEROES',
    'top.her.n': 'You have access to supreme heroes!',
    'top.her.1': 'Supreme heroes are the strongest heroes in the game.',
    'top.her.2': 'As a rule, supreme heroes possess force up to level 5.',
    'h.top': 'SUPREME',
    'top.inf.1': 'Supreme heroes cannot be exchanged. However, they are eligible for the same discounts as mythical heroes.',
    'quality': 'QUALITY',
    'qi': 'Image Quality',
    'qi.set': 'Set the image quality. High quality is recommended on powerful devices. On older devices, use low quality for better performance.',
    'nd.re': 'A game restart is required for the changes to take effect',
    'q.lst': 'Very Low',
    'q.lw': 'Low',
    'q.st': 'Standard',
    'q.hg': 'High',
    'knl.d': 'September',
    'it.levs': 'ITEM LEVEL SCALE:',
    'impr': 'Upgrade: ',
    'spdp': 'Acceleration: ',
    'art.d': 'DISCOUNTS ON ITEMS!',
    'art.d.d': 'DISCOUNTS STARTING AT 70% ON ALL ITEMS AND AMULETS!',
    'watch': 'VIEW',
    't.c.e': 'EVENT DATES: ',
    'clan.invite': 'invited to the clan',
    'clan.joined': 'joined the clan',
    'clan.reject': 'declined the clan invitation',
    'clan.kick': 'kicked from the clan',
    'clan.left': 'left the clan',
    'clan.raise': 'promoted to a new rank',
    'clan.subsidence': 'demoted',
    'clan.goldDonated': 'donated gold to the clan',
    'clan.redCrystalDonated': 'donated red crystals to the clan',
    'clan.blueCrystalDonated': 'donated blue crystals to the clan',
    'clan.gemsDonated': 'donated emeralds to the clan',
    'clan.gearsDonated': 'collected gears for the clan',
    'clan.leaderReplace': 'transferred leadership to',
    'clan.created': 'started a building upgrade',
    'clan.subLeader': 'appointed a deputy in the clan',
    'clan.upgradeWallOfFame': 'upgraded the clan\'s Wall of Fame',
    'clan.changeDescription': 'changed the clan description',
    'clan.changeTheme': 'changed the clan theme',
    'clan.giveAdvertisement': 'posted an announcement in the clan',
    'clan.changeDifficulty': 'changed the clan quest difficulty',
    'one.free': 'Once a day – free!',
    'hlw': 'Halloween',
    'wall.r.7': 'IMPENETRABILITY RNG. 7',
    'wall.r.7.gn': 'IMPENETRABILITY RNG. 7',
    'death.r.7': 'DEATH RNG. 7',
    'death.r.7.gn': 'DEATH RNG. 7',
    'witch.5.1': '– X6 AGAINST GOLEMS',
    'witch.5.2': '– IGNORES GOLEM\'S SHIELD',
    'witch.5.3': '– FORCES THE ENEMY TO ATTACK AN ALLIED HERO TWICE',
    'witch.7.1': '– X6 AGAINST GOLEMS, IGNORES GOLEM\'S SHIELD',
    'witch.7.2': '– FORCES THE ENEMY TO ATTACK AN ALLIED HERO TWICE',
    'witch.7.3': '– FORCES ENEMIES TO JOIN A GROUP ATTACK WITH YOU',
    'skip.mv': 'SKIP TURN',
    'sk.mv': 'TURN SKIP',
    'mag.r.2': 'MAGE RNG.2',
    'mag.r.2.gn': 'MAGE RNG.2',
    'chaos.r.7': 'CHAOS RNG. 7',
    'chaos.r.7.gn': 'CHAOS RNG. 7',
    'chaos.7.1': 'IGNORES 99.9999% OF THE ENEMY\'S DEFENSE',
    'pl.on': 'Player at',
    'th.pl': '-th place',
    'rl': 'Road length: ',
    'km': 'km.',
    'h.d': ' – big discount!',
    't.p': 'TO THE PORTAL',
    'pt': 'PORTAL',
    'discount': 'DISCOUNT',
    'discount.any': 'ON EVERYTHING',
    '8mr': 'March 8',
    'brth': 'Game\'s Birthday',
    'cat.rain': 'What on earth is that!?',
    'hum.rain': 'It\'s just rain, friends. These things happen – it\'ll be over soon.',
    'road.edge.forward.only': 'Only forward, my friend!',
    'road.edge.no.miss': 'We won\'t miss a thing!',
    'road.edge.go.boldly': 'Let us go boldly forward!',
    'ntr': 'New quest: Follow The White Rabbit!',
    'help': 'TO THE RESCUE',
    'h.h': 'I hear the call for help. Someone\'s in danger! Onward!',
    'thirty.emeralds': '30 emeralds',
    'hundred.emeralds': '100 emeralds',
    'five.hundred.emeralds': '500 emeralds',
    'thousand.emeralds': '1000 emeralds',
    'gft.by.code': 'PROMO GIFT!',
    'gft.by.code.text': 'With promo code VIP you receive a gift chest with ',
    'gft.by.code.text2': ' emeralds!',
    'with.love': 'With love, Your Mirrorland!!!',
    'm': 'm.',
    'pc.': 'pcs.',
    'card.elephant': 'Battle Elephant Card',
    'card.snake': 'Snake Card',
    'card.eagle': 'Eagle Card',
    'card.mouse': 'Loyal Friend Card',
    'card.mithril10k': 'Emerald Card',
    'card.elephant.tutorial': 'Now just select a hero and give the force as usual. Enjoy zero cost on the instant upgrade.',
    'you.activated.card': 'You activated the card!',
    'card.mithril10k.tutorial': 'You will instantly receive 10,000 emeralds.',
    'available': 'Available',
    'card.is.active': 'Card is active',
    'choose.hero.and.improve.force': 'Choose a hero and improve the force',
    'choose.hero.and.improve.rank': 'Choose a hero and improve the rank',
    'no.force.upgrades': 'No active hammers to speed up.',
    'ban.reason': 'Select a ban reason',
    'ban.reason.flood': 'Flood',
    'ban.reason.profanity': 'Profanity',
    'ban.reason.insults': 'Insults',
    'ban.reason.provocative.action': 'Provocation',
    'ban.reason.trade': 'Trade',
    'ban.reason.advertisement': 'Trade',
    'ban.reason.fraud': 'Fraud',
    'ban.reason.nickname': 'Banned nickname',
    'ban.reason.banned.topics': 'Banned topics',
    'ban.reason.laws': 'Russian laws',
    'hero.for.the.quest': 'COMPLETE THE QUEST AND RECEIVE A MYTHIC HERO ',
    'cost': ' COSTING ',
    'emeralds': ' EMERALDS.',
    'emeralds.small': 'emeralds ',
    'sulphur': ' amethysts.',
    'share': 'SHARE (+15 EMERALDS)',
    'share2': 'SHARE',
    'text.is.too.long': 'Text is too long',
    'level': ' (lvl. ',
    'purchase': 'Purchase ',
    'emeralds.for': ' emeralds for ',
    'gift.emeralds.for': ' emeralds as a gift for ',
    'payment.id': 'Payment ID: ',
    'receiver.id': 'Receiver ID: ',
    'payment.srated': 'PAYMENT STARTED',
    'emeralds.accrued.but.not.received': 'EMERALDS ACCRUED BUT NOT RECEIVED',
    'return': 'RETURN',
    'gain.part.of.friend.emeralds': 'Invite friends and get up to 45% of emeralds from each of their purchases',
    'send.ref.link.to.friend': 'SEND YOUR UNIQUE REFERRAL LINK TO A FRIEND',
    'filter.by.category': 'Filter by category:',
    'filter.by.subcategory': 'Filter by subcategory:',
    'filter': 'Filter',
    'social.invite.text': 'Play in Mirrorland with me!',
    'social.invite.bonus': 'Get a starter bonus of 99 emeralds!',
    'again.in': 'AGAIN IN ',
    '1h': '1 hr',
    '3h': '3 hrs',
    '6h': '6 hrs',
    '12h': '12 hrs',
    '1d': '1 day',
    '3d': '3 days',
    '1w': 'one week',
    '2w': 'two weeks',
    'copied.large': 'COPIED',
    'copied.id': 'ID COPIED TO CLIPBOARD',
    'source': 'SOURCE:',
    'unban': 'UNBAN',
    'unban.question': 'Unban the player?',
    'log.in.as.a.player': 'LOG IN AS A PLAYER',
    'history': 'HISTORY',
    'payments': 'PAYMENTS',
    'moderator.upgrade': 'PROMOTE TO MODERATOR',
    'moderator.upgrade.success': 'Player promoted to moderator',
    'moderator.downgrade': 'DEMOTE TO PLAYER',
    'moderator.downgrade.success': 'Moderator demoted to a regular player',
    'more': 'MORE',
    'openly.improve': 'UPGRADE UNLOCKED TO ',
    'level.up': ' LEVEL!',
    'mythical.hero': 'MYTHICAL HERO',
    'heroes.island': 'HEROES ISLAND',
    'not.enough.amethysts': 'Not enough amethysts',
    'amethysts.you.have': 'You have amethysts: ',
    'angels.city': 'CITY OF ANGELS',
    'accept.angel': 'Accept the angel into your ranks.',
    'appmetrica.active': 'AppMetrica is activating',
    'appmetrica.success': 'AppMetrica activated successfully',
    'appmetrica.error': 'An error occurred while activating AppMetrica',
    'get.gift': 'CLAIM YOUR GIFT!',
    'join.group': 'JOIN THE GROUP',
    'join.group.official': 'JOIN THE OFFICIAL GROUP ON ODNOKLASSNIKI',
    'donate': 'GIVING ',
    'donate.all': ' EMERALDS TO ALL GROUP MEMBERS!',
    'you.are.in.group': 'You\'re in the group. Accept the emeralds!',
    'join.group.donate': 'Join the group to receive emeralds.',
    'you.got.amethysts': 'Emeralds received!',
    'accept.donate': 'Accept the emeralds',
    'in.group': 'To the group',
    'oops': 'Oops',
    'you.used.action': 'You have already used this promotion.',
    'heroes.gate': 'HEROES\' CASTLE',
    'buy.unique.hero.from.castle': 'Buy a unique hero from the Heroes\' Castle.',
    'bath.broom': 'A bath whisk, a fresh towel, and slippers have been provided',
    'player.unbanned': 'Player unbanned',
    'accept.15.donate': 'Accept 15 emeralds!',
    'game.credits': 'Mirrorland game currency',
    'market.s': 'SUR MARKET',
    'accept.hero.from.market.s': 'Accept a hero from the Sur Market into your ranks.',
    'titan.gate': 'TITANS\' CASTLE',
    'buy.unique.hero.from.castle.titan': 'Buy a unique hero from the Titans\' Castle.',
    'city.yotunov': 'Jotun City',
    'accept.hero.from.city.yotunov': 'Accept the jotun into your ranks.',
    'intro': 'Mirrorland: adventures, battles, cats. Join the game!',
    'game.name': 'Mirrorland Game',
    'htr': 'Excellent',
    'mults': 'CARTOONS',
    'koschey': 'The Deathless',
    'koschey.gn': 'The Deathless',
    'cyclop': 'CYCLOPS',
    'cyclop.gn': 'CYCLOPS',
    'poison': 'Naga',
    'poison.gn': 'Naga',
    'keeper': 'KEEPER',
    'keeper.gn': 'KEEPER',
    'sphinx': 'SPHINX',
    'sphinx.gn': 'SPHINX',
    'norn': 'NORN',
    'norn.gn': 'norns',
    'provocator': 'PROVOCATOR',
    'provocator.gn': 'PROVOCATOR',
    'shadow': 'SHADOW',
    'shadow.gn': 'SHADOW',
    'priestess': 'PRIESTESS',
    'priestess.gn': 'PRIESTESS',
    'as': 'Aesir',
    'as.gn': 'Aesir',
    'young': 'YOUNG',
    'epic': 'EPIC',
    'shad.tn': 'Spectral City',
    'get.p': 'PURCHASE UNBOXING',
    'h.w.u': 'THE HERO IS NOW WITH US!',
    'also.bon': 'AND BONUS EMERALDS!',
    'also.bon.2': 'AND ALSO AS PART OF THE BONUS PROGRAM!',
    's.h': 'HEALTH BAG',
    'p.all': '% TO EACH HERO',
    'tick': 'WHEEL TICKETS!',
    'all.hero.7': 'All heroes\' forces can be upgraded to Rank 7 (later to Rank 12)',
    'ns.f': 'Summoning heroes requires the power of Nook-Serra',
    'hv': 'OWNED: ',
    'disc.mth': ' FOR MYTHIC HEROES ',
    'free.gms': 'FREE EMERALDS – JUST CLAIM THEM!',
    'an.y.m': 'Another... You',
    'an.y.w': 'Another... You',
    'cont': 'TO BE CONTINUED!',
    'and.nw': 'And now...',
    'wlcm': 'WELCOME!',
    'wn': 'WHAT WILL HAPPEN NEXT?',
    't.a': 'ONWARD TO ADVENTURE!',
    'port.shp': 'Summoning Portal',
    'sht.sur': 'Sur',
    'sht.port': 'Portal',
    'sm.cln': 'Clanmate',
    'kln': 'Clan: ',
    'by.ap': 'By apples',
    'pr.free': 'Free entry to any portal',
    'az.conds': 'Buy 3,000 emeralds or more and get the Azure Chest!',
    'az.det': 'What could be inside the Azure Chest?',
    'lv.conds': 'Buy 50,000 emeralds or more and get the Lava Chest!',
    'lv.det': 'What could be inside the Lava Chest?',
    'by.bk': 'By books',
    'by.pk': 'By pumpkins',
    'po.konfetam': 'For the candies',
    'p1.1': '*** You have completed Part I of the game! ***',
    'p1.2': 'It was a marvelous, storybook adventure.',
    'p1.3': 'And the journey continues!',
    'p1.4': 'You\'re already soaring through a portal to Legendary Asgard.',
    'p1.5': 'For now, accept our fiery congratulations!',
    'p1.6': 'Stay with us, in the most epic game – in Mirrorland!',
    'p1.7': 'Accept our warmest wishes, and may success follow you on your journey.',
    'p1.8': 'In the meantime, you can already see the light...',
    'p1.9': 'Asgard awaits you.',
    'p1.10': 'PART II.',
    'lgo': 'ONWARD!',
    'p2.1': '*** You have completed Part II of the game! ***',
    'p2.2': 'You have grown as strong as the storm and as swift as the wind.',
    'p2.3': 'You saved not only Mirrorland, but Asgard as well, and even the Emerald City.',
    'p2.4': 'You return to your world, and you will never be the same again.',
    'p2.5': 'And your journey continues!',
    'p2.6': 'Mirrorland still has surprises to astonish you – oh, so many!',
    'p2.7': 'Meanwhile, you have arrived in your world.',
    'p2.8': 'Onward, toward a new adventure!',
    'p2.9': 'PART III. Lord Ramses.',
    'p3.1': '*** You have completed Part 3 of the game! ***',
    'p3.2': 'Please accept our warmest congratulations, dear friend!',
    'p3.3': 'You have completed three parts – and now you are truly one of us.',
    'p3.4': 'One of the Chosen of Mirrorland! A part of Mirrorland!',
    'p3.5': 'We are truly glad to have you with us. May the wondrous, epic spirit never abandon you!',
    'p3.6': 'Meanwhile, a new challenge awaits you...',
    'p3.7': 'PART IV. WARLOCKS',
    'p4.1': '*** You have completed Part 4 of the game! ***',
    'p4.2': 'You have vanquished incredibly powerful foes and once more proven that you are the best!',
    'p4.3': 'Please accept our deepest gratitude!',
    'p4.4': 'Thank you for standing with us – for being one of our own!',
    'p4.5': 'Ahead of you lies one of the most intriguing and epic chapters of the game!',
    'p4.6': 'And now, onward! The Elder has something to tell you!',
    'p4.7': 'PART V. THE WITCH',
    'amb.conds': 'Buy 7,000 emeralds or more and get an Amber Chest!',
    'amb.det': 'What could be inside an Amber Chest?',
    'jd.conds': 'Buy 20,000 emeralds and receive a Jade Chest!',
    'jd.det': 'What could be inside a Jade Chest?',
    'art.slot': 'ARTIFACT SLOT',
    'amtst': ' amethysts',
    'mboo': 'Platinum Set',
    'p8.1': 'Surely, Sculd has overcome Dark Serra.',
    'p8.2': 'But Sculd was too late.',
    'p8.3': 'The Dark Nook-Serra bought time and saved you.',
    'p8.4': 'A nameless power carries you through a long portal tunnel.',
    'p8.5': 'At last, you glimpse the light...',
    'p8.6': 'Welcome to Paxhaven.',
    'p8.7': 'You are hurtling toward a chasm. The rush of it steals your breath.',
    'p8.8': 'It becomes unbearably hot. Your skin burns...',
    'p8.9': 'You plunge into molten lava...',
    'p8.10': 'Thoughts abandon you...',
    'p8.11': 'Welcome...',
    'p8.12': '... into the Abyss...',
    'p8.13': 'You used the key',
    'p8.14': 'At the last moment you saw Sculd\'s body stir.',
    'p8.15': 'She began to come back to life.',
    'p8.16': 'But it was too late for her.',
    'p8.17': 'Alas, Sculd will remain in the Abyss forever.',
    'p8.18': 'You, however, are already racing back toward your home world.',
    'p8.19': 'You made it.',
    'fireRobeMarker.info': 'The fire robe grants you strength in this battle',
    'waterRobeMarker.info': 'The water robe grants you strength in this battle',
    'mar': 'Faina',
    'marko': 'Liam',
    'turn': 'TURN',
    'wfr': 'THE WAY TO THE TURN IS CLEAR',
    'cmb': 'to the combat team',
    'cht': 'WHAT KINDS OF CHESTS ARE THERE?',
    'chd': '✨ Click a chest to view its description ✨',
    'p.q': 'Claim unique packs one by one!',
    'pr.pck': 'Claim previous packs first',
    'compl': 'completed',
    'got': 'received',
    'b.fr': 'Sale',
    's.n.s': 'Please wait for the sale to begin',
    'qty': 'in stock: ',
    'rst': 'left: ',
    'sold': 'sold out',
    'lst': 'last pack! (',
    'bf.welc': '✨ WELCOME TO THE SALE! ✨',
    'bf.st': 'The pack sale will start at 12:00 MSK',
    'bf.ts': 'Starts in:',
    'bf.welc.2': '✨ PACK SALE! ✨',
    's.c': 'SNOW CITY',
    'have.cav': 'You have caviar: ',
    'offs': 'OFFERS',
    'r.got': 'RANK EARNED! WELL DONE!',
    's.e': 'SNOW ELEPHANT',
    'cav': 'CAVIAR',
    'cav.g': ' CAVIAR',
    'n.e.c': ' Not enough caviar!',
    's.dp': 'Diala\'s Shop',
    'dp.tab': 'PACKS',
    'dp.agit': 'Exclusive packs for those who have reached the islands!',
    'dp.empty': 'Diala hasn\'t prepared anything yet. Check back later!',
    's.hc': 'HONEY TOWER',
    's.hr': 'HONEY CASTLE',
    's.hh': 'HONEY TEREM',
    's.plan_b': 'PLAN B',
    'sc.sell': 'SELL',
    'sc.no.cards': 'You don\'t have that card!',
    'sc.conf': 'Sell one {0} card for {1} honey?',
    'sc.sold': 'Card sold!',
    's.golden_door': 'GOLDEN DOORS',
    'sh.sell': 'LEAVE',
    'sh.conf': 'Leave hero {0} behind the Golden Doors? You\'ll receive {1} honey. The hero cannot be returned.',
    'sh.sold': 'The hero remained in Pandora!',
    'have.honey': 'You have honey: ',
    'n.e.h': 'Not enough honey!',
    'med': 'Honey',
    'med.g': 'HONEY',
    'discount.20percent.mythical.heroes': '20% DISCOUNT ON MYTHICAL HEROES',
    'to.purchase': 'To purchase',
    'to.player.him': 'to him',
    'to.player.her': 'to her',
    'for.player.him': 'for him',
    'for.player.her': 'for her',
    'special.gift': 'A special gift from {0}!',
    'buying.gems.for': 'Buying emeralds for',
    'make.a.special.gift': 'Make a special gift for a player!',
    'gift.from': 'Gift from {0}',
    'pss.1': 'Thank you for your purchase!',
    'pss.2': 'The gift has been sent and will reach its recipient very soon. Enjoy the game and have a wonderful time!',
    'g.p.w': '* Discounts on chests and the wheel do not apply to gifts sent to another player.',
    'something.special': 'Something special!',
    'p3': 'Atlantis for free',
    'p5': 'Tropics for free',
    'p6': 'Water Tribe for free',
    'p3.i': 'Atlantis',
    'p5.i': 'Tropics',
    'p6.i': 'Water Tribe',
    'p3.d': 'Free entry to the Atlantis portal!',
    'p5.d': 'Free entry to the Tropics portal!',
    'p6.d': 'Free entry to the Water Tribe portal!',
    'card.snake.tutorial': 'Choose a hero and the boon that will get an 80% discount and an 80% speed boost',
    'card.eagle.tutorial': 'Choose a hero to rank up',
    'card.mouse.tutorial': 'Instantly completes all force upgrades',
    'card.evolution.universal': 'Evolution',
    'card.evolution.ace': 'Evolution into an Aesir',
    'card.evolution.luck': 'Evolution into Luck',
    'card.evolution.chaos': 'Evolution into Chaos',
    'card.evolution.death': 'Evolution into Death',
    'card.evolution.druid': 'Evolution into a Druid',
    'card.evolution.dryad': 'Evolution into a Dryad',
    'card.evolution.faceless': 'Evolution into The Faceless',
    'card.evolution.gorgon': 'Evolution into a Gorgon',
    'card.evolution.berserk': 'Evolution into a Berserker',
    'card.evolution.skuld': 'Evolution into Skuld',
    'card.evolution.sikji': 'Evolution into Sikji',
    'card.evolution.urd': 'Evolution into Urd',
    'card.evolution.verdandi': 'Evolution into Verdandi',
    'card.evolution.highlander': 'Evolution into a Highlander',
    'card.evolution.human': 'Evolution into a Human',
    'card.evolution.inaccessibility': 'Evolution into Inaccessibility',
    'card.evolution.incubus': 'Evolution into an Incubus',
    'card.evolution.inkub': 'Evolution into an Incubus',
    'card.evolution.koschei': 'Evolution into The Deathless',
    'card.evolution.koschey': 'Evolution into The Deathless',
    'card.evolution.manticore': 'Evolution into a Manticore',
    'card.evolution.nun': 'Evolution into a Nun',
    'card.evolution.phoenix': 'Evolution into a Phoenix',
    'card.evolution.rider': 'Evolution into a Rider',
    'card.evolution.shadow': 'Evolution into a Shadow',
    'card.evolution.sphinx': 'Evolution into a Sphinx',
    'card.evolution.succubus': 'Evolution into a Succubus',
    'card.evolution.witch': 'Evolution into a Witch',
    'detail': 'More detailes',
    'evolution': 'Evolution',
    'evolution_text': 'Evolution of the force [currentForce] into the force [targetForce]',
    'evolution.gifts': 'Replacement of the [selectedClass] force of hero [hero name]',
    'evolution.selectForce': 'Select a force to replace',
    'evolution_description': 'The epic card \'Evolution\' lets you replace any force with any of the following:',
    'incompatible.force': 'Incompatible with force ',
    'incompatible.force.phoenix': 'Phoenix',
    'incompatible.force.shadow': 'Bright Shadow',
    'incompatible.force.inkub': 'Incubus',
    'incompatible.force.succub': 'Succubus',
    'card.evolution.universal.tutorial': 'Select a hero and a force, then replace it with a new one from the available list',
    'card.evolution.ace.tutorial': 'Select a hero and a force, then transform it into the Aesir force',
    'card.evolution.luck.tutorial': 'Select a hero and a force, then transform it into the Luck force',
    'card.evolution.chaos.tutorial': 'Select a hero and a force, then transform it into the Chaos force',
    'card.evolution.death.tutorial': 'Select a hero and a force, then transform it into the Death force',
    'card.evolution.dryad.tutorial': 'Select a hero and a force, then transform it into the Dryad force',
    'card.evolution.faceless.tutorial': 'Select a hero and a force, then transform it into The Faceless force',
    'card.evolution.gorgon.tutorial': 'Select a hero and a force, then transform it into the Gorgon force',
    'card.evolution.berserk.tutorial': 'Select a hero and a force, then transform it into the Berserker force',
    'card.evolution.skuld.tutorial': 'Select a hero and a force, then transform it into the Skuld force',
    'card.evolution.sikji.tutorial': 'Select a hero and a force, then transform it into the Sikji force',
    'card.evolution.urd.tutorial': 'Select a hero and a force, then transform it into the Urd force',
    'card.evolution.verdandi.tutorial': 'Select a hero and a force, then transform it into the Verdandi force',
    'card.evolution.human.tutorial': 'Select a hero and a force, then transform it into the force of the Human',
    'card.evolution.inkub.tutorial': 'Select a hero and a force, then transform it into the force of the Incubus',
    'card.evolution.koschey.tutorial': 'Select a hero and a force, then transform it into the force of The Deathless',
    'card.evolution.manticore.tutorial': 'Select a hero and a force, then transform it into the force of the Manticore',
    'card.evolution.nun.tutorial': 'Select a hero and a force, then transform it into the force of the Nun',
    'card.evolution.phoenix.tutorial': 'Select a hero and a force, then transform it into the force of the Phoenix',
    'card.evolution.rider.tutorial': 'Select a hero and a force, then transform it into the force of the Rider',
    'card.evolution.shadow.tutorial': 'Select a hero and a force, then transform it into the force of the Shadow',
    'card.evolution.sphinx.tutorial': 'Select a hero and a force, then transform it into the force of the Sphinx',
    'card.evolution.sukkub.tutorial': 'Select a hero and a force, then transform it into the force of the Succubus',
    'card.evolution.witch.tutorial': 'Select a hero and a force, then transform it into the force of the Witch',
    'card.evolution.druid.tutorial': 'Select a hero and a force, then transform it into the force of the Druid',
    'active': 'Activate!',
    'cancel.card.action': 'Cancel card action',
    'p2': 'Eden for free',
    'p2.i': 'Eden',
    'p2.d': 'Free entry to the Eden portal!',
    'amulet.shop': 'Amulet Shop',
    'amulets': 'AMULETS',
    'am.comm': 'Rare amulets with unique bonuses',
    'eff.att': 'ATTACK +{0}',
    'eff.def': 'DEFENSE +{0}',
    'eff.a.d': 'ATTACK AND DEFENSE +{0}',
    'eff.hl': 'HEALTH +{0}',
    'eff.k.att': 'Damage vs. The Deathless +{0}',
    'eff.k.def': 'Defense vs. The Deathless +{0}',
    'eff.pois': 'Poisons +{0}',
    'eff.res': 'Resurrections +{0}',
    'eff.ink': 'Protection vs. Incubus rng. {0}',
    'eff.suk': 'Protection vs. Succubus rng. {0}',
    'eff.wit': 'Protection vs. Witch rng. {0}',
    'eff.ham': 'Protection vs. Hammers rng. {0}',
    'eff.enf': 'Extra attacks vs. Shadows +{0}',
    'eff.gor': 'Protection vs. Gorgons rng +{0}',
    'eff.death.doll': 'Death Doll',
    'eff.weakening.doll': 'Weakness Doll',
    'eff.execution.doll': 'Execution Doll',
    'eff.life.doll': 'Life Doll',
    'eff.resurrection.doll': 'Resurrection Doll',
    'eff.carnage.doll': 'Rage Doll',
    'eff.stone.doll': 'Stone Doll',
    'eff.fire.doll': 'Fire Doll',
    'eff.charm.doll': 'Charm Doll',
    'manticore': 'MANTICORE',
    'sukkub': 'Succubus',
    'inkub': 'Incubus',
    'rider': 'Rider',
    'nun': 'Nun',
    'fire': 'FIRE ELEMENT',
    'gorgon': 'Gorgon',
    'lightshadow': 'Bright Shadow',
    'martyr': 'Martyr',
    'dryad': 'DRYAD',
    'abyssoul': 'ABYSSAL SOUL',
    'faceless': 'The Faceless',
    'babayaga': 'The Crone of the Woods',
    'manticore.gn': 'MANTICORES',
    'sukkub.gn': 'Succubus',
    'inkub.gn': 'Incubus',
    'rider.gn': 'Rider',
    'nun.gn': 'Nun',
    'fire.gn': 'FIRE ELEM.',
    'gorgon.gn': 'Gorgon',
    'lightshadow.gn': 'Bright Shadow',
    'martyr.gn': 'Martyr',
    'dryad.gn': 'DRYADS',
    'abyssoul.gn': 'ABYSSAL SOULS',
    'faceless.gn': 'The Faceless',
    'babayaga.gn': 'The Crone of the Woods',
    'need.ns': 'Requires Nook-Serra',
    'need.ns.count': 'Need {count} more Nook-Serra',
    'token': 'TOKEN',
    'ark': 'ARK',
    'tokens': 'TOKENS',
    'ur.tokens': 'You have tokens:',
    'ark.hlp.1': 'Ark: premium heroes',
    'ark.hlp.2': 'All Ark heroes have 12 force',
    'ark.hlp.3': 'Any hero of the Ark can be exchanged back for tokens',
    'ark.hlp.4': 'More Ark heroes – higher maximum rank',
    'ark.d.1.1': 'Welcome to the Ark!',
    'ark.d.1.2': 'Ark heroes are premium heroes for exceptionally wealthy players.',
    'ark.d.1.3': 'Only purchase them if the amounts shown aren\'t large for you and the purchase won\'t cause financial hardship.',
    'ark.d.1.4': 'Remember, this is only a game!',
    'ark.d.3': 'Any hero from the Ark can be exchanged back for the same number of tokens for which the hero was bought.',
    'ark.d.4.1': 'More heroes – higher max. rank.',
    'ark.d.4.2': 'Limits on rank upgrades and force increase when you buy Ark heroes.',
    'ark.d.4.3': 'For example, Balthazar is a hero whose force caps at rank 15.',
    'ark.d.4.4': 'However, with another Ark hero present, Balthazar’s rank and all his force can be upgraded to 16. Two more – to 17, and so on.',
    'ya.promo.1': 'You have successfully redeemed the promo code and now receive a special bonus: 100 emeralds!',
    'ya.promo.2': 'You have successfully redeemed the promo code and now receive a special bonus: +100% Experience for 8 hours!',
    'ya.promo.3': 'You receive a special bonus: Silver Pack! Super-bonuses for 1 hour! Experience +100%, Health per level +100%, Regeneration speed X10!',
    'ya.promo.4': 'You receive a special bonus: Gold Pack! Super-bonuses for 24 hours! Experience +200%, Health per level +200%, Regeneration speed X10!',
    'r.10': 'RANK 13',
    'elit': 'ELITE',
    'mon': 'MONASTERY',
    'mon.cc': 'Place of Mystery',
    'no.tok': 'Not enough tokens!',
    'need.ark': 'Requires +1 Ark hero',
    'do.exch': 'Exchange!',
    'p9.1': '*** The prophecy was shattered long before the recent upheavals. ***',
    'p9.2': 'It happened long ago, when a young hero, unmoored from his past, stepped onto the road of Mirrorland.',
    'p9.3': 'This wasn\'t supposed to happen... But here you are.',
    'p9.4': 'Our god is an eternal child – heedless, for whom there is nothing but games.',
    'p9.5': 'Every game is a pastime to him, but to us it is the fate of Nonexistence...',
    'p9.6': 'We cannot stand against The One God – it is instant death.',
    'p9.7': 'Yet one day a hero from another world will come to our aid...',
    'p1': 'City of Dreams – Free',
    'p7': 'Monk Valley – Free',
    'p1.i': 'CITY OF DREAMS',
    'p1.d': 'Free entry to the City of Dreams portal!',
    'p7.i': 'MONK VALLEY',
    'p7.d': 'Free entry to the Monk Valley portal!',
    'eff.fire': 'Fire Res. rng +{0}',
    'clan.all': 'to clanmates',
    'acc': 'ACCOUNT',
    'ac.no': 'Don\'t ask again',
    'ac.sg': 'Would you like to continue the game from another of your accounts?',
    'ac.cm1': 'Very well!',
    'ac.cm2': 'But for reference: you can select an account later in the Menu -- Profile ',
    'group': 'GROUPS',
    'group.upgrade.title': 'QUICK UPGRADE',
    'group.upgrade.select': 'WHICH HERO WILL WE UPGRADE\nARTIFACTS FOR?',
    'group.upgrade.current': 'Current Hero',
    'group.upgrade.all': 'All Heroes',
    'group.upgrade.count': 'You can start upgrading\n{count} artifacts:',
    'ne.hvataet.resursov': 'Not enough resources',
    'group.upgrade.none': 'No artifacts selected for upgrade',
    'cmb.cl': 'to all clanmates',
    'tasty': 'TASTY',
    'pets': 'PETS',
    'g.vip': 'SPECIALS',
    'g.sum': 'SUMMER',
    'bonus.title': 'Faction Bonus',
    'bonus.sun': 'The Sun faction bonus is active: your random hero receives +1 resurrection',
    'bonus.moon': 'The Moon faction bonus is active: all your heroes\' defense against The Deathless increases by 10%',
    'select.source': 'Weakening Hero',
    'select.target': 'Strengthening Hero',
    'podtverdit.perenos': 'Confirm Transfer',
    'transfer.confirm.text': 'Are you sure you want to transfer power from hero {source} to hero {target}?\nThe hero you chose will lose all stats, forces and ranks.\nThe other hero will receive 25% of his power permanently.\nComplete the transfer?',
    'hero.exchange': 'Hero Exchange',
    'hero.exchange.confirmation': 'Confirm hero exchange?',
    'no_cancel': 'No, cancel!',
    'yes_confirm': 'Yes!',
    'ark.sq.t': 'ARK HERO',
    'ark.sq.t.1.a': 'You have ',
    'ark.sq.t.1.b': ' Ark tokens.',
    'ark.sq.t.2': 'To include a hero in the active squad you must:',
    'ark.sq.t.3': 'Have at least 0 on your account – not less!',
    'ark.sq.adv': 'How do I do that?',
    'ark.sq.adv.1': '- Buy tokens',
    'ark.sq.adv.2': '– Defeat Sikji and claim the reward',
    'ark.sq.adv.3': '– Swap a hero in the Ark for a cheaper one',
    'card.ark': 'Ark card',
    'card.ark.effect': 'The selected hero will receive +2 to the limit for all ranks, and two additional forces of your choice!',
    'card.ark.pick': 'Simply choose a hero, then proceed to pick the forces!',
    'bonus.shadow': 'Shadow faction bonus active – the number of attacks of all your shadows is increased by 10%',
    'p10.1.1': 'Novice skillfully blended magic with a warrior\'s craft, a talent that set her apart from the other novices of the monastery…',
    'p10.1.2': 'One day, a girl came to the Monastery… A girl who hid her true intentions from her sisters…',
    'p10.1.3': 'Novice managed to expose her. She learned she had been forced into it under threat of death…',
    'p10.1.4': 'Novice helped her flee and punish the blackmailers. As for the Monastery… the traitor faced the gallows.',
    'p10.2.1': 'What no one had foreseen came to pass.',
    'p10.2.2': 'The One God has been defeated. Even Nonexistence did not grasp that, with his disappearance, it would lose its protection.',
    'p10.2.3': 'Void Dark surged to consume the world it had always sought to devour.',
    'p10.2.4': 'Void Dark consumed it… consuming itself.',
    'p10.2.5': 'It will be a long while before the fallen worlds are restored. But the process has already begun…',
    'pick.2': 'CHOOSE TWO FORCES',
    'card.ark.tutorial': 'The selected hero will receive +2 to the limit for all ranks, and two additional forces of your choice! Simply choose a hero, then proceed to pick the forces!',
    'update.app': 'Oops! Your app version is out of date. Please update the app via the Rustore store!',
    'gft.rst': 'GIFT FROM RUSTORE!',
    'ark.rdy': 'We\'re ready for the epic transformation! Confirm?',
    'rk.t': 'UNFATHOMABLE',
    'rk.1': 'It has come to pass.',
    'rk.2': 'The epic transformation has occurred!',
    'rk.3': 'ascends to a new unfathomable plane of existence.',
    'rk.4.1': 'Behold!',
    'rk.4.2': 'Ark!',
    'rk.err.1': 'No suitable heroes!',
    'rk.err.2': 'The card can only be applied to heroes of the Monastery, the Portal, and a handful of others.',
    'obl.1.1': 'Nonexistence.',
    'obl.1.2': 'Nothing here is permanent.',
    'obl.1.3': 'Neither time nor form.',
    'obl.1.4': 'Memory, consciousness, your identity.',
    'obl.1.5': 'All things blend into one.',
    'obl.1.6': 'How long has it been?',
    'obl.1.7': 'Only for a moment does reality take a familiar shape.',
    'obl.2.1': 'You are sent to the dungeon.',
    'obl.2.2': 'Here, in Nonexistence.',
    'obl.2.3': 'You can do nothing.',
    'obl.2.4': 'Your powers do not belong to you.',
    'obl.2.5': 'Nor your consciousness…',
    'w.mir.1': 'You fly through a shining vortex.',
    'w.mir.2': 'But... Something is wrong...',
    'w.mir.3': 'You find yourself... not in Paxhaven...',
    'fr.sh': 'Faction Shop',
    'fr.p': 'Order Points',
    'fr.t': 'Shadow Points',
    'fr.n.e': 'Not enough faction points',
    'by.scen': 'By scenario',
    'reputation': 'Reputation',
    'reputation.REPUTATION_WORLD': 'World Reputation',
    'reputation.REPUTATION_PIRATE': 'Pirate Reputation',
    'reputation.REPUTATION_INQUISITION': 'Reputation of the Inquisition',
    'reputation.REPUTATION_MAGES': 'Reputation of Mages',
    'reputation.REPUTATION_DEADWORLD': 'Dead World Reputation',
    'reputation.REPUTATION_UGABUGA': 'Tribesmen Reputation',
    'reputation.REPUTATION_HOBBITS': 'Reputation of Hobbits',
    'reputation.REPUTATION_SOUTHISLANDS': 'Southern Islands Reputation',
    'reputation.REPUTATION_BADPIRATES': 'Rogue Pirates Reputation',
    'ore.gold': 'Gold Ore',
    'mithril10k.applied.title': 'You have redeemed the card!!',
    'mithril10k.applied.body': 'You instantly receive 10,000 emeralds.\nMay they aid you in your travels!',
    'reputation.ORE_GOLD': 'Gold Ore',
    'sirenia': 'Sirenia',
    'arto': 'Arto',
    'braveryMarker.info': '"Bravery" grants +20% attack but removes all defense for this battle',
    'thunderMarker.info': '"Thunder" weakens your opponent',
    'p4': 'Antarctica – Free',
    'p4.i': 'ANTARCTICA',
    'p4.d': 'Free entry to the Antarctica Portal!',
    'p8': 'Pandora for Free',
    'p8.i': 'PANDORA',
    'p8.d': 'Free entry to the Pandora portal!',
    'skuld_as': 'Sculd + Aesir',
    'skuld_as.gen': 'Sculd + Aesir',
    'urd': 'URD',
    'urd.gen': 'URD',
    'verdandi': 'Verdandi',
    'verdandi.gen': 'Verdandi',
    'ns_oblivion': 'Nook-Serra Nonexistence',
    'ns_oblivion.gen': 'Nook-Serras Nonexistence',
    'rider_balt': 'Rider of Nonexistence',
    'rider_balt.gen': 'Rider of Nonexistence',
    'nun_sukkub': 'Nun + Succubus',
    'nun_sukkub.gen': 'Nun + Succubus',
    'promo.code': 'PROMO CODE',
    'promo.code.description': 'Enter the promo code. It is valid for a limited time and can be activated only once.',
    'promo.code.reward': 'Your promo code rewards',
    'promo.hero.new': 'NEW HERO',
    'sboo': 'Silver Set',
    'or': 'or',
    'reg.google': 'Sign up with Google',
    'login.google': 'Log in with Google',
    'reg.apple': 'Sign up with Apple',
    'login.apple': 'Log in with Apple',
    'reputation.sulphur': 'Amethysts',
    'reputation.honey': 'Honey',
    'exit.lost': 'Are you sure you want to exit? Progress will be lost.',
    'zavershennye': 'COMPLETED',
    'collect.all.task.rewards': 'COLLECT ALL\nREWARDS',
    'kr.1': 'We saw the night...',
    'kr.2': 'We wandered all night until dawn...',
    'pv4.m.1': 'You have walked through fire and ash.',
    'pv4.m.2': 'You defeated those whom even the shadows feared.',
    'pv4.m.3': 'You became part of Mirrorland.',
    'pv4.m.4': 'Now his roads are your roads.',
    'pv4.m.5': 'His losses – your memory.',
    'pv4.m.6': 'His light – your strength.',
    'pv4.m.7': 'Dear friend! Now you are one of us.',
    'pv4.m.8': 'And... you have completed the first part of the game.',
    'pv4.w.1': 'You have walked through fire and ash.',
    'pv4.w.2': 'You have defeated those whom even shadows feared.',
    'pv4.w.3': 'You have become part of Mirrorland.',
    'pv4.w.4': 'Now his paths are your paths.',
    'pv4.w.5': 'His losses are yours to remember.',
    'pv4.w.6': 'His light is your strength.',
    'pv4.w.7': 'Fair Queen! Now you are one of us.',
    'pv4.w.8': 'And... you have completed the first part of the game.',
    'pc.mouse.1.m': 'You are my champion',
    'pc.mouse.1.f': 'You are my champion',
    'pc.mouse.2': 'I am always by your side',
    'pc.mouse.3': 'Never give up',
    'pc.elli.1': 'Music is with you',
    'pc.elli.2': 'Music lives on',
    'pc.elli.3.m': 'Sing, dear friend',
    'pc.elli.3.f': 'Sing, dear friend',
    'pc.kayra.1.m': 'You are special',
    'pc.kayra.1.f': 'You are special',
    'pc.kayra.2': 'Never give up',
    'pc.zirael.1': 'Light guides you',
    'pc.zirael.2': 'Do not doubt',
    'pc.zirael.3': 'See it through',
    'pc.alex.1': 'With love',
    'pc.alex.2': 'Together forever!',
    'pc.alex.3': 'We are by your side',
    'pc.ct.love': 'With love',
    'pc.ct.together.forever': 'Together forever!',
    'pc.ct.forever.together': 'Forever together!',
    'pc.ct.wonderland.forever': 'Mirrorland Forever!',
    'pc.ct.with.us': 'You are with us',
    'pc.ct.we.near': 'We are by your side',
    'pc.ct.with.you': 'Together with you',
    'pc.ct.forever': 'Forever!',
    'pc.ct.wonderland': 'Mirrorland!',
    'pc.ct.love2': 'Love',
    'pc.ct.together': 'Together!!',
    'pc.ct.love.en': 'Love',
    'pc.ct.love.en3': 'Love Love Love',
    'pc.ct.best.game': 'Best Game',
    'pc.ct.wonderland2': 'Mirrorland!!',
    'pc.ct.first.game': 'First Game!!',
    'pc.ct.best.game2': 'Best Game!',
    'pc.ct.you.best.m': 'You are the best!',
    'pc.ct.you.best.f': 'You are the best!',
    'pc.ct.we.together': 'We are together!',
    'pc.ct.will.succeed': 'You will succeed!',
    'pc.ct.with.us.forever': 'With us forever!',
    'pc.ct.we.love': 'We love',
    'pc.ct.you.super': 'You are awesome!',
    'island.arena.title': 'ARENA OF Dealiah',
    'island.arena.description': 'You stand within the unique arena of the Dealiah Tribesman!\nYou cannot see your opponent beforehand.\nBoth you and your foe have first-rank forces and classes.\nHere your Attack, Health and Defense decide the outcome!\nDolls, potions, scrolls and amulets all work.\n6 attempts per day, you may purchase up to six more.\nMay fortune favor you!',
    'island.arena.reward.info': 'For victory +{0} gold ore\nFor defeat −{1} gold ore',
    'island.arena.attempts': 'Attempts: {0} / {1}',
    'island.arena.continue.attack': 'CONTINUE',
    'island.arena.buy.attempts': '{0} TIMES.\n\nBUY\n1 ATTEMPT',
    'island.arena.not.enough.attempts': 'Not enough attempts',
    'common.retry.error': 'Error. Please try again',
    'p2.v4.mk.1': 'Poisoned water sears your throat.',
    'p2.v4.mk.2': 'The world begins to drift.',
    'p2.v4.mk.3': 'The sand slips from beneath your feet.',
    'p2.v4.mk.4': 'Your body no longer obeys.',
    'p2.v4.mk.5': 'Someone\'s cold hands bind you in iron.',
    'p2.v4.mk.6.m': 'The heiress calls you by name…',
    'p2.v4.mk.6.w': 'The heir calls you by name…',
    'p2.v4.mk.7': 'or is it only your imagination...',
    'p2.v4.tt.1': 'Crystals flare at the Great Trees.',
    'p2.v4.tt.2': 'The phoenix egg awakens at the heart of the circle.',
    'p2.v4.tt.3': 'Time opens the door.',
    'p2.v4.tt.4': 'The key in your hand grows heavy, as if it were fate itself.',
    'p2.v4.tt.5': 'Now you understand.',
    'p2.v4.tt.6': 'You must give it to yourself.',
    'p2.v4.tt.7': 'You take a step, and the past learns your footsteps.',
    'heir_f': 'heiress',
    'heir_m': 'heir',
    'p2v4.m.1': 'You came to Asgard as a stranger.',
    'p2v4.m.2': 'But became his hope.',
    'p2v4.m.3': 'You brought water back to those who were dying of thirst.',
    'p2v4.m.4': 'You saved those who believed in you to the end.',
    'p2v4.m.5': 'And you escorted those who never saw the dawn.',
    'p2v4.m.6': 'Dear friend…',
    'p2v4.m.7': 'Now Asgard lives in your heart.',
    'p2v4.m.8': 'And... you have completed the second part of the game.',
    'p2v4.w.1': 'You came to Asgard as a stranger.',
    'p2v4.w.2': 'But you became his hope.',
    'p2v4.w.3': 'You returned water to those who were dying of thirst.',
    'p2v4.w.4': 'You saved those who believed in you until the very end.',
    'p2v4.w.5': 'And you escorted those who never saw the dawn.',
    'p2v4.w.6': 'Dear friend…',
    'p2v4.w.7': 'Now Asgard lives in your heart.',
    'p2v4.w.8': 'And... you have completed the second part of the game.',
    'pc.believer.1': 'I always believe in you',
    'pc.believer.2': 'Chosen One',
    'pc.believer.3': 'We live because of you',
    'pc.heir.1': 'I love you',
    'pc.heir.2': 'I live for you',
    'pc.heir.3': 'I\'m waiting for you',
    'pc.heir.4': 'Only you',
    'pc.elder.1': 'Chosen One',
    'pc.elder.2': 'You have prevailed',
    'pc.ashira.1': 'In the name of the Chosen',
    'pc.ashira.2': 'Prophecy',
    'to.13.1': 'The body hurtles into the unknown',
    'to.13.2': 'The only thing ahead is the road',
    'to.13.3': 'Of which the ash whispered',
    'to.13.4': 'What awaits us there?',
    'to.13.5': 'Will we find our way to Asgard?',
    'to.13.6': 'My mind is left with nothing but words...',
    'to.13.7': '13th Way',
    'from.13.1': 'The body races through the light.',
    'from.13.2': 'The Thirteenth Way lies behind us.',
    'from.13.3': 'Maps. Gates. The voices of those,',
    'from.13.4': 'who helped you get this far.',
    'from.13.5': 'Ahead lies Asgard.',
    'from.13.6': 'A home of thunder, ash, and an old promise.',
    'from.13.7': 'But what awaits us there?',
    'p3v4.m.1': 'You found your way to Asgard,',
    'p3v4.m.2': 'when all roads had been stolen.',
    'p3v4.m.3': 'You passed through the 13th Way',
    'p3v4.m.4': 'and saved Asgard from the Black Book.',
    'p3v4.m.5': 'Dear friend...',
    'p3v4.m.6': 'you have completed the third part of the game.',
    'p3v4.w.1': 'You found your way to Asgard,',
    'p3v4.w.2': 'when all roads had been stolen.',
    'p3v4.w.3': 'You passed through the 13th Way',
    'p3v4.w.4': 'and saved Asgard from the Black Book.',
    'p3v4.w.5': 'Beloved queen...',
    'p3v4.w.6': 'you have completed the third part of the game.',
    'kayra': 'Kayra',
    'kael': 'Kael',
    'koschey.doll': 'The Deathless Doll',
    'inferno.doll': 'Inferno Doll',
    'goodness.doll': 'Doll of Goodness',
    'hopelessness.doll': 'Doll of Hopelessness',
    'koschey.doll.desc': 'Removes the shields of The Deathless\nfrom all creatures on the battlefield.\nAffects bosses.',
    'inferno.doll.desc': 'Ignites all allies and enemies.\nAffects bosses.',
    'goodness.doll.desc': 'Extinguishes burning on all\nyour heroes, but reduces\ntheir attack to 1.\nAffects bosses.',
    'hopelessness.doll.desc': 'The chosen enemy turns to stone\nfor the remainder of the battle and cannot be resurrected\n(does not work on bosses)',
    'eff.koschey.doll': 'The Deathless Doll',
    'eff.inferno.doll': 'Inferno Doll',
    'eff.goodness.doll': 'Doll of Goodness',
    'eff.hopelessness.doll': 'Doll of Hopelessness',
    'magical_shamisen': 'MAGICAL SHAMISEN',
    'ore_miner': 'ORE MINER',
    'magical_shamisen.gen': 'OF THE MAGICAL SHAMISEN',
    'ore_miner.gen': 'OF THE ORE MINER',
    'zadanija.filter': 'Quest Filter',
    'zadanija.filter.none': 'No filter',
    'zadanij.filtra.net': 'No quests found for the selected filter',
    'island.antigua': 'Antigua',
    'island.dialya': 'Dealiah',
    'island.hunganami': 'Henginamie',
    'island.tortuga': 'Tortuga',
    'island.efira': 'Isle of Efira',
    'island.lukomorye': 'Lukomorye',
    'craft.recipes.place.ship': 'Crafting table in Rkachi\'s house, the tribesmen\'s village on Dealiah Island. A crafting table is also in your cabin aboard your ship.',
    'craft.hint.mira_spear': 'Mira (Rogue Pirate ship, Henginamie) pays more for spears',
    'craft.hint.sallivan_bouquet_bad': 'Sullivan (at his house on the Pier, Henginamie) pays more for simple bouquets',
    'craft.hint.morgan_bouquet_good': 'Captain Morgan (Rogue Pirate ship, Henginamie) pays more for expensive bouquets',
    'ship.visit.title': 'Captains',
    'ship.visit.visit': 'Visit',
    'ship.visit.leave': 'Leave',
    'ship.visit.empty': 'No captains with ships yet',
    'ship.visit.more': 'More',
    'pu.reward_x10_for_win': 'Sphere of Wealth',
    'pu.elixir_for_win': 'Trial Crystal',
    'pu.attack-half-to-all': 'Chest of Cards',
    'pu.gin_defence': 'Salvation Crystal',
    'pu.charmMarker': 'Factory of the Alchemist',
    'pu.charm2': 'Factory of the Alchemist',
    'pu.blueElvenFlowerMarker': 'Blue Flower',
    'pu.redElvenFlowerMarker': 'Red Flower',
    'pu.yellowElvenFlowerMarker': 'Yellow flower',
    'pu.stealCurseMarker': 'Haunted House',
    'pu.witchLuckMarker': 'Witch Hut',
    'pu.threePowerCone': 'Pine Cone',
    'pu.fairyMarker': 'House of the Fairy',
    'pu.snowflakeMarker': 'Winner\'s Snowflake',
    'pu.p6tavPotionMarker': 'Tavern potion',
    'pu.cloverMarker': 'Lucky Clover',
    'pu.fireRobeMarker': 'Veil of Fire',
    'pu.waterRobeMarker': 'Veil of Water',
    'pu.luckyCat': 'Lucky cat',
    'pu.healthPlus3Marker': 'Flower of Immortality',
    'pu.kettle': 'Dragon decoction',
    'pu.healthPlus25': 'Magical Whirlpool',
    'pu.summonCopyMarker': 'Arcane Vortex',
    'pu.deathCrystal': 'Death Crystal',
    'pu.idolOfDestruction': 'Idol of Destruction',
    'pu.mushDefence500marker': 'Mushroom of Invulnerability',
    'pu.mushAttack500marker': 'Frenzy Mushroom',
    'pu.serpentForce': 'Serpent Fungus',
    'pu.superDefence': 'Ethereal Mushroom',
    'pu.mushroomMarker': 'Berserker\'s Mushroom',
    'pu.mushroomMarker2': 'Shaman\'s Mushroom',
    'pu.looseForcePhoenix': 'Phoenix Dread',
    'pu.looseForceDeath': 'Vitality Stone',
    'pu.looseForceWitch': 'Witch Nightmare',
    'pu.looseForceMag': 'Sorcerer\'s Nightmare',
    'pu.exp_x10': 'Sphere of Wisdom',
    'pu.anyHeroAttackX3': 'Sphere of Titans',
    'pu.3_vict_sphere': 'Sphere of Trial',
    'pu.new_level_on_victory': 'Sphere of Enlightenment',
    'pu.braveryMarker': 'Bravery',
    'pu.thunderMarker': 'Thunder',
    'auth.error': 'Authorization error',
    'auth.google.prefix': 'Google authorization error: ',
    'auth.google.sign.in': 'Google sign-in error',
    'auth.apple.sign.in': 'Apple sign-in error',
    'auth.google.sign.up': 'Google sign-up error',
    'auth.apple.sign.up': 'Apple sign-up error',
    'auth.google.sdk': 'Google SDK is not loaded.',
    'auth.google.sdk.later': 'Google SDK is not loaded. Please try again later.',
    'auth.apple.sdk.later': 'Apple SDK is not loaded. Please try again later.',
    'auth.google.old.app': 'Update the app: Google sign-in is unavailable in this version.',
    'auth.app.bad.response': 'Invalid response from the app',
    'gp.not.ready': 'GamePush is not initialized',
    'gp.payments.unavailable': 'GamePush payments are unavailable',
    'mon10.forces.hint': 'All hero forces on this tab can be upgraded to rank 13 (best victory: lvl. 50,000).',
    'mon.ex.ny.hint': '* You will be able to buy some of these heroes in the pre-New Year events!',
    'ark.ns.exchange.title': 'Hero Exchange',
    'ark.ns.exchange.question': 'Confirm hero exchange?',
    'ark.ns.exchange.body': 'Exchanging removes Nook-Serra from your team, and you receive 50 tokens.',
    'ark.ns.exchange.note': '* The exchange does not affect the Summoning Portal: an exchanged Nook-Serra still counts toward the total there.',
    'ark.sell.for.tokens': 'Sell the hero for tokens?',
    'chat.time.just.now': 'just now',
    'chat.time.at': 'at {0}',
    'chat.time.yesterday.at': 'Yesterday at {0}',
    'chat.time.date.at': '{0} at {1}',
    'chat.time.minutes.one': '{0} minute ago',
    'chat.time.minutes.few': '{0} minutes ago',
    'chat.time.minutes.many': '{0} minutes ago',
    'chat.time.hours.one': '{0} hour ago',
    'chat.time.hours.few': '{0} hours ago',
    'chat.time.hours.many': '{0} hours ago'
}
